import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  FormGroup,
  TableSortLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Collapse,
  Popper,
  Divider,
  IconButton,
  Menu,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useLayoutEffect, useRef, useState, useCallback, useMemo } from "react";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
// import { ReactComponent as OrderIcon } from "Assets/Icons/PharmsmartIcon/Order.svg";
import { ReactComponent as EventIcon } from "Assets/Icons/PharmsmartIcon/ReapetOrder.svg";
import { ReactComponent as AddIcon } from "../../Assets/Icons/AddIcon.svg";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import { ReactComponent as WarningIcon } from "../../Assets/Icons/WarningIcon.svg";
import { ReactComponent as ErrorIcon } from "../../Assets/Icons/ErrorIcon.svg";
import { ReactComponent as SettingIcon } from "../../Assets/Icons/SettingsIcon.svg";
import { ReactComponent as ordersIcon } from "../../Assets/Icons/ordersIcon.svg";
import { ReactComponent as printIcon } from "../../Assets/Icons/printIcon.svg";
import { ReactComponent as Refresh } from "../../Assets/Icons/refresh.svg";
import { ReactComponent as ModalCloseIcon } from "../../Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import { connect, useSelector } from "react-redux";
import {
  START_GET_REPEAT_ORDER_LIST,
  RESET_REPEAT_ORDER_STATE,
  START_DELETE_REPEAT_ORDER,
  START_UPDATE_GLOBAL_SETTING,
  START_GET_PRINT_REPEAT_ORDER_LIST,
  START_UPDATE_REPEAT_ORDER_NOTE,
  START_DELETE_REPEAT_ORDER_NOTE,
  START_GET_OOS_ORDER,
  START_ORDER_COUNT_TYPE,
  START_GET_SINGLE_REPEAT_ORDER,
  START_BULK_ORDER_COUNT,
  START_GET_BULK_ORDER_LIST,
} from "../../Actions/RepeatOrderAction";
import {
  RESET_PATIENT_STATE,
  START_GET_PATIENT_NOTE_LIST,
  START_CREATE_PATIENT_NOTE,
  START_UPDATE_PATIENT_NOTE,
  START_DELETE_PATIENT_NOTE,
  START_GET_SINGLE_PATIENT_NOTE,
  START_GET_PATIENT_LIST,
  START_GET_SINGLE_PATIENT,
  START_GET_PATIENT_MEDICATION_HISTORY_LIST,
  START_ARCHIVE_MEDICATION,
} from "../../Actions/PatientAction";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import { useIntersection } from "../../Hooks/customHooks";
import _ from "underscore";
import {
  getClearObject,
  getLocalStorage,
  setLocalStorage,
  getNewOrder,
} from "../../utils/generalUtils";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import "../../Sass/Common.scss";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import { statusMenuItems } from "../../utils/data";
import RepeatOrderTable from "./RepeatOrderTable";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import Chips from "../../Components/Common/Chips";
import TableColumnShowMenu from "../Common/Table/TableColumnShowMenu";
import { ReactComponent as FilterIcon } from "../../Assets/Icons/FilterIcon.svg";
import { ReactComponent as EmailIcon } from "../../Assets/Icons/email (1).svg";
import SearchAndFilterDialogMobileView from "./SearchAndFilterDialogMobileView";
import { START_GET_HOME_LIST } from "../../Actions/HomeAction";
import useViewport from "../../Hooks/useViewport";
import HtmlTooltip from "../../Components/Common/HtmlTooltipMain";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import parse from "html-react-parser";
import { sanitizeHtml } from "../../utils/sanitize";
import PageLoading from "../../Components/Common/PageLoading";
import PatientActionColumn from "./PatientActionColumn";
import SurgeryAutoComplete from "../../Components/Patients/SurgeryAutoComplete";
import GroupAutoComplete from "../../Components/Patients/GroupAutoComplete";

const MultiOrderDialog = React.lazy(() => import("./MultiOrderDialog"));
const SendEmailOrdersDialog = React.lazy(() => import("./SendEmailOrdersDialog"));
const ReviewRequiredWaringDialog = React.lazy(() => import("./ReviewRequiredWaringDialog"));
const EarlyMultipleOrderDialog = React.lazy(() => import("./EarlyMultipleOrderDialog"));
const InfomationDialog = React.lazy(() => import("./InfomationDialog"));
const PRNReviewDialog = React.lazy(() => import("./PRNReviewDialog"));
const OrderPlaceDialog = React.lazy(() => import("./OrderPlaceDialog"));
const PatientDetailDialog = React.lazy(() => import("../../Components/Patients/PatientDetailDialog"));
const SubscriptionWaringDailog = React.lazy(() => import("../../Components/Common/Dialog/SubscriptionWaringDailog"));
const AddCycleDialog = React.lazy(() => import("./AddCycleDialog"));

const OutOfSyncTemplateDialog = React.lazy(
  () => import("./OutOfSyncTemplateDialog"),
);
const ConfirmDialog = React.lazy(() => import("./ConfirmDialog"));
const ConfirmationDialog = React.lazy(
  () => import("../../Components/Common/Dialog/ConfirmationDialog"),
);
const PatientAndOrderNoteDialog = React.lazy(
  () => import("./PatientAndOrderNoteDialog"),
);
const GlobalSettingDialog = React.lazy(() => import("./GlobalSettingDialog"));
const EditDateDialog = React.lazy(() => import("./EditDateDialog"));

const PrintRepeatOrderList = React.lazy(() => import("./PrintRepeatOrderList"));
const OrderNoteDialog = React.lazy(
  () => import("../../Components/RepeatOrder/OrderNoteDialog"),
);
const OrderMedicationDataDialog = React.lazy(
  () => import("./OrderMedicationDataDialog"),
);
const EditDateConfirmationDialog = React.lazy(
  () => import("./EditDateConfirmationDialog"),
);

const useStyle = makeStyles((theme) => ({
  autoCompleteBox: {
    background: theme.palette.white.main,
    boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    lineHeight: "30px",
    marginRight: "20px !important",
    minWidth: "280px !important",
    whiteSpace: "onwrap",
    marginTop: "0px",
    "&>div": {
      marginTop: "0px !important",
    },
    [theme.breakpoints.down(1451)]: {
      minWidth: "280px !important",
      width: "300px !important",
      marginRight: "10px !important",
      marginLeft: "10px !important",
    },
    [theme.breakpoints.down(1280)]: {
      minWidth: "184px !important",
    },
    [theme.breakpoints.down("1301")]: {
      display: "none !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  rsPatientHeader: {
    display: "flex",
    justifyContent: "end",
    whiteSpace: "nowrap",
    marginRight: "6px",
    [theme.breakpoints.down(1301)]: {
      marginRight: "0px",
    },
    [theme.breakpoints.down("585")]: {
      width: "auto !important",
      display: "flex !important",
      flexDirection: "row !important",
    },
    "&>button": {
      marginLeft: "20px",
      whiteSpace: "nowrap",
      height: "37px !important",
      marginRight: "10px",
    },
    "&>div": {
      width: "200px",
      height: "37px !important",
      [theme.breakpoints.down(1301)]: {
        width: "127px !important",
      },
      [theme.breakpoints.down(900)]: {
        width: "123px !important",
      },
      [theme.breakpoints.between(769, 880)]: {
        marginRight: "3px",
      },
      // [theme.breakpoints.down("1600")]: {
      //   display: "none !important",
      // },
      "&>div": {
        height: "37px !important",
        "&>div": {
          height: "37px !important",
        },
      },
    },
  },
  tableHead: {
    "& .MuiTableContainer-root": {
      // maxHeight: "calc(96vh - 200px) !important",
      // padding: "13px !important",
      padding: "0px !important",
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              whiteSpace: "nowrap !important",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "0px",
                zIndex: 4,
              },
              "&:last-child": {
                position: "sticky",
                right: "0px",
                padding: "0 10px !important",
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              whiteSpace: "nowrap !important",
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  reRepeatOrderCheckBox: {
    backgroundColor: " #333",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 6px",
    [theme.breakpoints.down(1350)]: {
      gap: "5px !important",
    },
    [theme.breakpoints.between(769, 880)]: {
      flexDirection: "column !important",
      "&>div": {
        width: "100%",
        justifyContent: "start !important",
        marginLeft: "1px",
      },
      "&>div:nth-child(1)": {
        marginBottom: "3px",
      },
    },
    [theme.breakpoints.down(500)]: {
      display: "block",
      gap: "0px !important",
    },
  },
  reRepeatOrderMobile: {
    backgroundColor: " #333",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    padding: " 6px 6px",
    [theme.breakpoints.down(769)]: {
      paddingLeft: "25px !important",
      paddingRight: "20px !important",
    },
    [theme.breakpoints.down(1301)]: {
      padding: " 0px 0px",
    },
  },
  reRepeatOrderMobileIcon: {
    backgroundColor: " #333",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    padding: " 6px 6px",
    [theme.breakpoints.down(900)]: {
      padding: " 0px",
    },
    [theme.breakpoints.down("585")]: {
      padding: "0px",
    },
  },
  editDate: {
    "&:hover": {
      lineHeight: "24px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  iconBtn: {
    marginTop: "0px !important",
    borderRadius: "10% !important",
  },
  rsprintButton: {
    height: "37px !important",
    width: "55px !important",
    // marginLeft: "5px !important",
    "&>button": {
      padding: "0px !important",
      minWidth: "42px !important",
    },
    [theme.breakpoints.down("1301")]: {
      marginLeft: "0px !important",
      marginRight: "0px !important",
    },
  },
  rsprintButtonUser: {
    height: "37px !important",
    width: "37px !important",
    marginLeft: "5px !important",
    "&>button": {
      padding: "0px !important",
      minWidth: "42px !important",
      display: "flex !important",
      justifyContent: "center",
    },
    [theme.breakpoints.up("1175")]: {
      display: "none",
    },
  },
  printButton: {
    height: "37px !important",
    width: "37px !important",
    marginLeft: "5px !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
      fill: "white",
    },
  },
  printButtonUser: {
    height: "37px !important",
    width: "37px !important",
    marginLeft: "5px !important",
    "&>svg": {
      height: "20px !important",
      width: "20px !important",
    },
    [theme.breakpoints.down("768")]: {
      display: "none !important",
    },
    [theme.breakpoints.down("1175")]: {
      display: "block !important",
    },
    [theme.breakpoints.up("1175")]: {
      display: "none !important",
    },
  },
  todaysOrderStyle: {
    display: "-webkit-inline-box  !important",
    alignItems: "baseline;",
    whiteSpace: "nowrap",
    marginLeft: "5px",
    "&>div": {
      height: "37px !important",
      marginTop: "1px",
    },
    "&>button": {
      padding: "15px 18px !important",
      marginRight: "10px !important",
      height: "37px !important",
    },
    [theme.breakpoints.down("1356")]: {
      marginLeft: "0px",
    },
    [theme.breakpoints.between(769, 880)]: {
      "&>button": {
        marginRight: "4px !important",
      },

    },
    [theme.breakpoints.down("585")]: {
      width: "100%",
      display: "flex !important",
      flexDirection: "row !important",
      justifyContent: "start !important",
      gap: '10px !important',
      marginBottom: "10px  !important",
      marginLeft: "0px  !important",
      marginRight: "0px !important",
      alignItems: "center",
      "&>button": {
        marginLeft: "0px  !important",
        marginRight: "0px !important",
      },
    },
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        whiteSpace: "nowrap !important",
        [theme.breakpoints.down("1853")]: {
          padding: "2px 19px",
        },
        [theme.breakpoints.down("1700")]: {
          padding: "2px 14px  !important",
        },
        [theme.breakpoints.down("1601")]: {
          padding: "2px 14px  !important",
        },
        [theme.breakpoints.down("1501")]: {
          padding: "2px 14px  !important",
        },
        paddingLeft: "16px !important",
      },
    },
  },
  rsCursor: {
    cursor: "pointer",
  },
  dayAutocomplete: {
    background: theme.palette.white.main,
    boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    lineHeight: "30px",
    minWidth: "120px !important",
    maxWidth: "163px !important",
    whiteSpace: "onwrap",
    "&>div": {
      marginTop: "2px",
      padding: "10px",
      color: theme.palette.secondary.main,
      fontSize: "14px",
      height: "23px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiMenuItem": {
      color: theme.palette.secondary.main,
    },
  },

  globalSettingIcon: {
    margin: "-8px 8px 5px",
  },
  rsFilterIcon: {
    padding: "0px 0px !important",
    fontSize: "14px !important",
    height: "32px !important",
    marginTop: "-11px !important",
    marginRight: "15px !important",
  },
  GlobalSettingAndDays: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    paddingLeft: "25px !important",
    marginBottom: "12px",
    marginTop: "-7px",
    [theme.breakpoints.up("1366")]: {
    },
    [theme.breakpoints.down(769)]: {
      marginRight: "25px",
    },
    [theme.breakpoints.down(410)]: {
      marginBottom: "0px",
      marginTop: "0px",
    },
    "&>div": {
      "&>button": {
        [theme.breakpoints.down(1600)]: {
          height: "38px !important",
          marginBottom: "0px !important",
        },
        [theme.breakpoints.down(410)]: {
          width: "166px",
          whiteSpace: "nowrap",
        },
      },
    },
  },
  rsInfoIcon: {
    marginRight: "5px",
    marginBottom: "-3px",
    width: "18px",
    cursor: "pointer",
    [theme.breakpoints.down(769)]: {
      left: "27px",
    },
  },
  iconGrey: {
    marginRight: "10px",
    "& :hover": {
      cursor: "pointer",
    },
    "&>g": {
      "&>path": {
        fill: "#5A6872",
      },
    },
    "&>path": {
      fill: "#5A6872",
    },
  },
  alignMenu: {
    "&>div": {
      left: "120px !important",
      top: "290px !important",
      "&>ul": {
        "&>li": {
          "& :disabled": {
            backgroundColor: "#5a6872 !important",
            color: "#FFFFFF",
          },
        },
      },
    },
  },
  margin: {
    marginRight: "10px",
    "& :hover": {
      cursor: "pointer",
    },
  },
  rsWaringMenu: {
    zIndex: "9",
    padding: "8px",
    backgroundColor: "white",
    position: "absolute",

    borderRadius: "10px",
    boxShadow:
      "0px 8px 15px rgba(110, 117, 130, 0.15), 0px 1px 2px rgba(110, 117, 130, 0.3)",
  },
  rsOrderBtn: {
    marginRight: "10px !important",
    position: "absolute !important",
    left: "273px",
    height: "30px !important",
  },
  rsMultiOrderBtn: {
    marginRight: "10px !important",
    position: "absolute !important",
    left: "114px",
    height: "30px !important",
    marginBottom: "15px !important",
  },
  rsTableCellHeader: {
    display: "flex",
    height: "19px",
  },
  rsPopperPage: {
    zIndex: "9",
    padding: "7px 21px 9px",
    backgroundColor: "white",
    position: "absolute",
    borderRadius: "10px",
    width: "190px",
    boxShadow:
      "0px 8px 15px rgba(110, 117, 130, 0.15), 0px 1px 2px rgba(110, 117, 130, 0.3)",
  },
  rsWaringFilterlistview: {
    "&>li": {
      display: "block",
      marginBottom: "10px",
      marginTop: "10px",
      "&>svg": {
        top: "5px",
        position: "relative",
      },
    },
  },
  rsDivider: {
    background: "#F7F7F8 !important",
    marginTop: "15px !important",
    marginBottom: "1px !important",
  },
  rsAppliedStyleBtn: {
    fontSize: "14px !important",
    height: "25px !important",
  },
  rsPopperbuttonAlign: {
    justifyContent: "space-around !important",
    display: "flex !important",
    "&>button": {
      padding: "0px !important",
    },
  },
  rsWaringCursor: {
    // display: "inline-flex",
    cursor: "pointer",
    // marginLeft: "5px",
  },
  rsWaringList: {
    display: "inline-flex",
    marginTop: "-6px",
    // marginLeft: "3px",
    "&>div": {
      "&>svg": {
        width: "20px",
        height: "20px",
      },
    },
  },
  rsIconFilterDispense: {
    // marginTop: "2px",
    top: "0px !important",
    "&>div": {
      "&>svg": {
        width: "20px",
        height: "20px",
      },
    },
  },
  rsListAlignment: {
    display: "flex",
    marginBottom: "11px",
    justifyContent: "space-between",
    "&>div": {
      display: "flex",
    },
  },
  rsActiveBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "10px",
    width: "10px",
    borderRadius: "5px",
    position: "relative",
    marginTop: "8px",
    marginLeft: "5px",
    justifyContent: "flex-start !important",
  },
  rsiconBtn: {
    display: "flex",
    position: "relative",
  },
  rsIconBtnWarning: {
    display: "flex",
    position: "relative",
    bottom: "-5px",
  },
  rsActiveIconBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "8px",
    width: "8px",
    borderRadius: "5px",
    marginTop: "8px",
    marginLeft: "5px",
    position: "absolute",
    left: "12px",
    top: "3px",
  },
  rsActiveIconWarBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "8px",
    width: "8px",
    borderRadius: "5px",
    marginTop: "8px",
    marginLeft: "5px",
    position: "absolute",
    left: "18px",
    top: "3px",
  },
  rsStatusmenuList: {
    position: "absolute",
    top: "0px",
    width: "0px",
    minWidth: "30px",
    left: "0px",
    height: "30px",
    opacity: "0",
  },
  rsSelectMenulist: {
    width: "30px",
    height: "21px",
    marginTop: "0px",
    marginLeft: "-6px",
    "&>div": {
      padding: "0px !important",
    },
  },
  rsStatusBox: {
    display: "flex",
    position: "relative",
    marginRight: "19px !important",
    marginTop: "-9px !important",
    "&>svg": {
      "&>path": {
        fill: "#5A6872  !important",
      },
    },
    "&>button": {
      cursor: "pointer",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  rsHtmlToolTip: {
    cursor: "pointer",
  },
  manageOpenCheckBox: {
    "& .MuiTableContainer-root": {
      padding: "0px !important",
      maxHeight: "calc(96vh - 200px) !important",
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              padding: "2px 13px !important",
              [theme.breakpoints.down(1400)]: {
              },
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "0px",
                zIndex: 4,
                minWidth: "79px !important",
                "&>label": {
                  "&>span": {
                    paddingLeft: "12px",
                  },
                },
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "79px",
                zIndex: 4,
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "0",
                zIndex: 3,
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 0,
                zIndex: 3,
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 0,
                zIndex: 3,
              },
              " &:nth-child(6)": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 0,
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(7)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(8)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 2,
              },
              " &:nth-child(11)": {
                position: "sticky",
                right: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              "&:nth-last-child(2)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: " 162px !important",
                zIndex: 4,
              },
              "&:last-child": {
                position: "sticky",
                right: "0px",
                padding: "0 10px !important",
                zIndex: 4,
                minWidth: "162px !important",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              height: "auto",
              [theme.breakpoints.down(1601)]: {
                padding: "2px 16px !important",
              },
              [theme.breakpoints.down(1500)]: {
                padding: "2px 12px !important",
              },
              "&:first-child": {
                background: "#FFFFFF",
                position: "sticky",
                left: "0px",
                zIndex: 3,
                top: "0px",
                minWidth: "79px !important",
              },
              " &:nth-child(2)": {
                whiteSpace: "nowrap",
                background: "#FFFFFF",
                position: "sticky",
                left: "79px",
                zIndex: 3,
                top: "0px",
              },
              " &:nth-child(3)": {
                whiteSpace: "nowrap",
                background: "#FFFFFF",
                position: "sticky",
                left: "0",
                zIndex: 2,
                top: "0px",
              },
              " &:nth-child(4)": {
                whiteSpace: "nowrap",
                background: "#ffffff",
                position: "sticky",
                left: "300px",
                top: "0px",
                zIndex: 1,
              },
              " &:nth-child(5)": {
                whiteSpace: "nowrap",
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
                top: "0px",
              },
              " &:nth-child(6)": {
                whiteSpace: "nowrap",
                background: "#ffffff",
                position: "sticky",
                left: 0,
                right: 0,
                zIndex: 1,
                top: "0px",
              },
              " &:nth-child(7)": {
                whiteSpace: "nowrap",
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
                top: "0px",
              },
              " &:nth-child(8)": {
                whiteSpace: "nowrap",
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
                top: "0px",
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
                top: "0px",
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
                top: "0px",
              },
              " &:nth-child(11)": {
                top: "0px",
                position: "sticky",
                right: 0,
                zIndex: 2,
              },
              "&:nth-last-child(2)": {
                background: "#ffffff",
                position: "sticky",
                right: "162px !important",
                padding: "0px 3px !important",
                textAlign: "center !important",
                zIndex: 3,
              },
              "&:last-child": {
                background: "#FFFFFF",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
                top: "0px",
                minWidth: "162px !important",
              },
            },
          },
        },
      },
    },
  },
  managePageH: {
    marginTop: "-5px",
    "& .MuiTableContainer-root": {
      maxHeight: "calc(100vh - 184px) !important",
      padding: "0px !important",
      // padding: "13px !important",
      [theme.breakpoints.down(1400)]: {
        maxHeight: "calc(93vh - 154px) !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              lineHeight: "0.8rem",
              padding: "11px 13px !important",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              [theme.breakpoints.down(1400)]: {
                padding: "11px 13px !important",
              },
              [theme.breakpoints.down(1500)]: {
                padding: "11px 13px !important",
              },
              "&:first-child": {
                position: "sticky",
                left: 0,
                zIndex: 4,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                position: "sticky",
                left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                position: "sticky",
                right: 0,
                zIndex: 3,
                left: 0,
                whiteSpace: "nowrap",
              },
              " &:nth-child(6)": {
                position: "sticky",
                right: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: "-21px",
                zIndex: 3,
                whiteSpace: "nowrap",
                [theme.breakpoints.down(1366)]: {
                  right: "0px",
                },
              },
              " &:nth-child(8)": {
                position: "sticky",
                right: 0,
                zIndex: 2,
                whiteSpace: "nowrap",
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 1,
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: "0px",
                // right: "-5px !important",
                zIndex: 3,
              },

              "&:nth-last-child(2)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: " 132px !important",
                zIndex: 4,
                padding: "11px 8px !important",
              },

              "&:last-child": {
                position: "sticky",
                right: 0,
                zIndex: 4,
                // padding: "16px 45px !important",
                minWidth: "132px !important",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              // minHeight: "50px !important",
              // height: "auto !important",
              // display: "block",
              [theme.breakpoints.down(1601)]: {
                padding: "2px 16px !important",
              },
              [theme.breakpoints.down(1500)]: {
                padding: "2px 8px !important",
              },
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
                minHeight: "50px !important",
                height: "auto !important",
                padding: "15px 20px !important",
                display: "block",
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(3)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(4)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(5)": {
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
                left: 0,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(6)": {
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 2,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(7)": {
                background: "#ffffff",
                position: "sticky",
                right: "-21px",
                zIndex: 2,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(8)": {
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 0,
                minHeight: "50px !important",
                height: "auto !important",
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: "0px",
                zIndex: 2,
                minHeight: "50px !important",
                height: "auto !important",
              },

              "&:nth-last-child(2)": {
                background: "#ffffff",
                position: "sticky",
                right: "132px !important",
                padding: "0px 3px !important",
                textAlign: "center !important",
                zIndex: 3,
                minHeight: "50px !important",
                height: "auto !important",
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
                minWidth: "132px !important",
                minHeight: "50px !important",
                height: "auto !important",
              },
            },
          },
        },
      },
    },
  },
  tableViewManage: {
    marginTop: "-5px",
    "& .MuiTableContainer-root": {
      // maxHeight: "calc(100vh - 148px) !important",
      maxHeight: "calc(96vh - 150px) !important",
      // padding: "13px !important",
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              lineHeight: "0.8rem",
              padding: "11px 13px !important",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                position: "sticky",
                left: 0,
                zIndex: 4,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                position: "sticky",
                left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                position: "sticky",
                right: 0,
                zIndex: 3,
                left: 0,
                whiteSpace: "nowrap",
              },
              " &:nth-child(6)": {
                position: "sticky",
                right: "-21px",
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: "0px",
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(8)": {
                position: "sticky",
                right: 0,
                zIndex: 2,
                whiteSpace: "nowrap",
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 1,
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 3,
              },
              "&:nth-last-child(2)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: "132px !important",
                zIndex: 4,
              },
              "&:last-child": {
                position: "sticky",
                right: 0,
                zIndex: 4,
                minWidth: "132px !important",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              [theme.breakpoints.down(1400)]: {
                padding: "2px 16px !important",
              },
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(3)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(4)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(5)": {
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
                left: 0,
              },
              " &:nth-child(6)": {
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 2,
              },
              " &:nth-child(7)": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",

                zIndex: 2,
              },
              " &:nth-child(8)": {
                background: "#ffffff",
                position: "sticky",
                right: 0,
                zIndex: 1,
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 0,
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                position: "sticky",
                right: "-5px",
                zIndex: 2,
              },
              "&:nth-last-child(2)": {
                background: "#ffffff",
                position: "sticky",
                right: "132px !important",
                padding: "0px 3px !important",
                textAlign: "center !important",
                zIndex: 3,
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
                minWidth: "132px !important",
              },
            },
          },
        },
      },
    },
  },
  managePageMobile: {
    "& .MuiTableContainer-root": {
      padding: "0px !important",
      [theme.breakpoints.down("1200")]: {
        maxHeight: "calc(100vh - 190px) !important",
      },
      [theme.breakpoints.down("885")]: {
        maxHeight: "calc(100vh - 220px) !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              // padding: "16px 13px !important",
              // [theme.breakpoints.down(1400)]: {
              //   padding: "16px 5px !important",
              // },
              // [theme.breakpoints.down(1500)]: {
              //   padding: "16px 4px !important",
              // },
              "&:first-child": {
                position: "sticky",
                // left: 0,
                zIndex: 4,
              },
              " &:nth-child(2)": {
                position: "sticky",
                // left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(3)": {
                position: "sticky",
                // left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(4)": {
                position: "sticky",
                // left: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(5)": {
                position: "sticky",
                // right: 0,
                zIndex: 3,
                // left: 0,
                whiteSpace: "nowrap",
              },
              " &:nth-child(6)": {
                position: "sticky",
                // right: 0,
                zIndex: 3,
                whiteSpace: "nowrap",
              },
              " &:nth-child(7)": {
                position: "sticky",
                // right: "-21px",
                zIndex: 3,
                whiteSpace: "nowrap",
                // [theme.breakpoints.down(1366)]: {
                //   right: "0px",
                // },
              },
              " &:nth-child(8)": {
                position: "sticky",
                // right: 0,
                zIndex: 2,
                whiteSpace: "nowrap",
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: 0,
                zIndex: 1,
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: "0px",
                // right: "-5px !important",
                zIndex: 3,
              },

              "&:nth-last-child(2)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: " 162px !important",
                zIndex: 4,
                padding: "12px 8px !important",
              },

              "&:last-child": {
                position: "sticky",
                // right: 0,
                zIndex: 4,
                padding: "16px 45px !important",
                minWidth: "162px !important",
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                // left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                background: "#ffffff",
                position: "sticky",
                // left: 0,
                zIndex: 1,
              },
              " &:nth-child(3)": {
                background: "#ffffff",
                position: "sticky",
                // left: 0,
                zIndex: 1,
              },
              " &:nth-child(4)": {
                background: "#ffffff",
                position: "sticky",
                // left: 0,
                zIndex: 1,
              },
              " &:nth-child(5)": {
                background: "#ffffff",
                position: "sticky",
                // right: 0,
                zIndex: 1,
                // left: 0,
              },
              " &:nth-child(6)": {
                background: "#ffffff",
                position: "sticky",
                // right: 0,
                zIndex: 2,
              },
              " &:nth-child(7)": {
                background: "#ffffff",
                position: "sticky",
                // right: "-21px",
                zIndex: 2,
              },
              " &:nth-child(8)": {
                background: "#ffffff",
                position: "sticky",
                // right: 0,
                zIndex: 1,
              },
              " &:nth-child(9)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: 0,
                zIndex: 0,
              },
              " &:nth-child(10)": {
                whiteSpace: "nowrap",
                position: "sticky",
                // right: "0px",
                zIndex: 2,
              },

              "&:nth-last-child(2)": {
                background: "#ffffff",
                position: "sticky",
                // right: "162px !important",
                padding: "0px 3px !important",
                textAlign: "center !important",
                zIndex: 3,
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                // right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
                minWidth: "162px !important",
              },
            },
          },
        },
      },
    },
  },
  rsGrid: {
    [theme.breakpoints.down(769)]: {
      padding: "5px !important",
    },
  },
  rsMobileView: {
    [theme.breakpoints.down(410)]: {
      marginBottom: "15px",
      paddingLeft: "25px !important",
    },
  },
  rsFilterIconUnCollectedOther: {
    "&>button": {
      padding: "0px 0px !important",
      fontSize: "14px !important",
      height: "37px !important",
      marginTop: "0px !important",
      marginLeft: "9px !important",
      "&>svg": {
        fill: `${theme.palette.primary.main} !important`,
      },
      [theme.breakpoints.down("1301")]: {
        minWidth: "42px !important",
        padding: "0px 0px !important",
        marginLeft: "4px !important",
      },
    },
  },
  rsAddIcon: {
    marginLeft: "24px !important",
  },
  rsSetting: {
    paddingTop: "6px",
  },
  rsSettingMob: {
    padding: "0px 0px !important",
    fontSize: "14px !important",
    height: "37px !important",
    marginTop: "0px !important",
    marginLeft: "9px !important",
    minWidth: "1px !important",
    "&>svg": {
      fill: `${theme.palette.primary.main} !important`,
    },
  },
  luPrncell: {
    alignItems: "center !important",
    "&>svg": {
      marginLeft: "5px",
      height: "20px",
      width: "20px",
      cursor: "pointer",
      marginBottom: "-4px",
    },
  },
  rsMainMarign: {
    [theme.breakpoints.down(768)]: {
      marginTop: "0px !important",
    },
  },
  search: {
    marginTop: "0px !important",
    marginRight: "9px !important",
    [theme.breakpoints.down("1301")]: {
      display: "none !important",
    },
  },
  redtext: {
    color: "red !important",
  },
  rsPageLoading: {
    width: "100%",
    height: "100%",
    zIndex: "1500 !important",
    background: "rgba(0, 0, 0, 0.3)",
    position: "absolute",
    display: "flex",
  },
  rsListAlignment: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "40px",
    "&>div": {
      display: "flex",
    },
  },
  rsiconBtnForFilter: {
    width: "auto !important",
    marginRight: "5px",
    "&>div": {
      // background: "#7BC044 !important",
      background: "white",
      display: "flex !important",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "5px",
      // cursor: "pointer",
      width: "auto !important",
      height: "40px !important",
      padding: "6px",
      "&>button": {
        padding: "4px",
        cursor: "pointer",
        color: "black",
        fontSize: "16px",
        fontWeight: "500",
        fontFamily: "Poppins !important",
        "&:hover": {
          background: "transparent",
        },
        "&>svg": {
          fill: "black",
          "&>rect": {
            fill: "black",
          },
          // fontSize: "35px",
        },
      },
    },
    "&>hr": {
      color: "#5A6872",
      background: "#5A6872",
      paddingTop: "5px",
      paddingBottom: "5px",
    },
  },
  customMenuItem: {
    "&:focus": {
      backgroundColor: "transparent !important", // Remove the background color on focus
      outline: "none !important", // Remove the outline on focus
    },
    "&:hover": {
      backgroundColor: "transparent !important", // Remove the background color on focus
      outline: "none !important", // Remove the outline on focus
    },
  },
  rsActiveBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "10px",
    width: "10px",
    borderRadius: "5px",
    position: "relative",
    marginTop: "8px",
    marginLeft: "5px",
    justifyContent: "flex-start !important",
  },
  rsWaringFilterlistview: {
    "&>li": {
      display: "block",
      marginBottom: "2px",
      // marginTop: "10px",
      "&>svg": {
        top: "5px",
        position: "relative",
      },
    },
  },
  rsCursor: {
    cursor: "pointer",
  },
  rsSurgeryAutoCompleteWebOther: {
    height: "37px",
    marginTop: "0px !important",
    marginBottom: "15px !important",
    width: "150px !important",
    marginBottom: "10px",
    [theme.breakpoints.down("1650")]: {
      width: "150px !important",
    },
    "&>div": {
      // border: "1px solid black !important",
      marginTop: "0px !important",
      "&>div": {
        border: "1px solid black !important",
        "&:focus": {
          borderColor: "#7BC044 !important",
        },
        "&:focus-within": {
          borderColor: "#7BC044 !important",
        },
      },
    },
  },
  ordergapMain: {
    "&>svg": {
      "&>path": {
        fill: "#E54C42",
      },
      "&>g": {
        "&>path": {
          // fill: "transparent",
          // stroke: "#E54C42",
          fill: "#E54C42",
        },
      },
    },
  },
  rsSurgeryAutoComplete: {
    height: "37px",
    marginTop: "0px !important",
    width: "150px !important",
    marginBottom: "15px",
    [theme.breakpoints.down("1650")]: {
      width: "150px !important",
    },
    "&>div": {
      marginTop: "0px !important",
      "&>div": {
        border: "1px solid black !important",
        "&:focus": {
          borderColor: "#7BC044 !important",
        },
        "&:focus-within": {
          borderColor: "#7BC044 !important",
        },
      },
    },
  },
  rsButtonHowtoIcon: {
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    "&>span": {
      marginLeft: "-8px",
    },
    "&>svg": {
      "&>path": {
        fill: "#7bc044 !important",
        stroke: "white",
      },
    },
  },
  rsButtonEmailIcon: {
    padding: "8px 15px !important",
    borderRadius: "5px !important",
    fontWeight: "600 !important",
    color: "white !important",
    borderColor: "#7BBD4B !important",
    textTransform: "none !important",
    marginLeft: "0px !important",
    height: "36px !important",

    "& svg": {
      "& path": {
        fill: "white",
        stroke: "none",
      },
    },
    [theme.breakpoints.down("525")]: {
      padding: "8px 10px !important",
    },
  },
  tableBodyLoading: {
    "&>tr": {
      "&>td": {
        display: "table-cell !important",
      },
    },
    width: "100px !important",
  },
  rsButtonHelpIcon: {
    color: "#7BBD4B !important",
    width: "25px !important",
    height: "auto !important",
    padding: "0px !important",
    marginTop: "0px !important",
    "&:hover": { backgroundColor: "transparent !important" },
    "& svg": {
      "& path": {
        fill: "primary.main",
        stroke: "none",
      },
    },
    [theme.breakpoints.down("525")]: {
      padding: "8px 10px !important",
      marginTop: "10px !important",
    }
  },
}));

/** head title */
const tableCells = {
  name: {
    id: "name",
    label: "PATIENT",
    sortable: true,
    checkBoxFlag: true,
    icons: true,
    show: true,
    showValue: false,
    print: true,
    apply: false,
  },
  order_date: {
    id: "order_date",
    label: "ORDER DATE",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  medication_date: {
    id: "medication_date",
    label: "MEDICATION DATE",
    sortable: true,
    icons: true,
    show: true,
    showValue: true,
    print: true,
    apply: true,
  },
  address: {
    id: "address",
    label: "ADDRESS",
    sortable: false,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  patien_medications_count: {
    id: "patien_medications_count",
    label: "NO OF MEDS",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  previous_order_date: {
    id: "previous_order_date",
    label: "LAST ORDERED",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  weeks: {
    id: "weeks",
    label: "RX DAYS",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  pharmacy_name: {
    id: "pharmacy_name",
    label: "PHARMACY",
    sortable: true,
    show: false,
    showValue: true,
    print: true,
    apply: false,
  },
  is_review_prn: {
    id: "is_review_prn",
    label: "ORDER REVIEW",
    sortable: false,
    show: true,
    showValue: false,
    print: false,
    apply: false,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    icons: false,
    show: true,
    showValue: false,
    print: false,
    apply: false,
  },
};

const tableCellsPharmacy = {
  name: {
    id: "name",
    label: "PATIENT",
    sortable: true,
    checkBoxFlag: true,
    icons: true,
    show: true,
    showValue: false,
    print: true,
    apply: false,
  },
  order_date: {
    id: "order_date",
    label: "ORDER DATE",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  medication_date: {
    id: "medication_date",
    label: "MEDICATION DATE",
    sortable: true,
    icons: true,
    show: true,
    showValue: true,
    print: true,
    apply: true,
  },
  address: {
    id: "address",
    label: "ADDRESS",
    sortable: false,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  patien_medications_count: {
    id: "patien_medications_count",
    label: "NO OF MEDS",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  surgery_name: {
    id: "surgery_name",
    label: "SURGERY",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  previous_order_date: {
    id: "previous_order_date",
    label: "LAST ORDERED",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  weeks: {
    id: "weeks",
    label: "RX DAYS",
    sortable: true,
    icons: false,
    show: true,
    showValue: true,
    print: true,
    apply: false,
  },
  is_review_prn: {
    id: "is_review_prn",
    label: "ORDER REVIEW",
    sortable: false,
    show: true,
    showValue: false,
    print: false,
    apply: false,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    icons: false,
    show: true,
    showValue: false,
    print: false,
    apply: false,
  },
};

const RepeatOrderMain = (props) => {
  const {
    getOrderListAction,
    repeatOrderList,
    resetOrderState,
    deleteRepeatOrderAction,
    deleteRepeatOrder,
    globalSetting,
    updateGlobalSettingAction,
    getPrintOrderListAction,
    printRepeatOrderList,
    getPatientNoteListAction,
    deleteRepeatOrderNoteAction,
    updateOrderNoteAction,
    updateRepeatOrderNoteData,
    deleteRepeatOrderNote,
    patientNoteList,
    createPatientNoteAction,
    createPatientNoteData,
    updatePatientNoteAction,
    updatePatientNoteData,
    deletePatientNoteAction,
    deletePatientNoteData,
    getSinglePatientNoteAction,
    singlePatientNoteData,
    resetPatientState,
    getOosOrderListAction,
    ossOrderList,
    getPatientListAction,
    getHomeListAction,
    getSinglePatientAction,
    singlePatientData,
    getPatientHistoryAction,
    patientMedicationHistoryList,
    archiveMedi,
    getMedicationArchiveAction,
    orderCountTypeList,
    getOrderCountTypeAction,
    getSingleRepeatOrderAction,
    singleRepeatOrder,
    getBulkOrderCountAction,
    orderCountOfBulkOrder,
    getBulkOrderListAction,
    bulkOrderList
  } = props;
  const classes = useStyle();
  const { width } = useViewport();
  const navigate = useNavigate();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [searchValue, setSearchValue] = useState(
    getLocalStorage("searchString") || ""
  );
  const [showPatientNoteList, setShowPatientNoteList] = useState({});
  const [openPatientNoteList, setOpenPatientNoteList] = useState(false);
  const [dlobalSettingDialogStatus, setDlobalSettingDialogStatus] =
    useState(false);
  const [deletePatient, setDeletePatient] = useState(false);
  const [isOpenEditDateModel, setIsOpenEditDateModel] = useState(false);
  const [orderRecordActionType, setIsOrderRecordActionType] = useState("");
  const [patientDeleteId, setPatientDeleteId] = useState("");
  const [editRepeatDate, setEditRepeatDate] = useState({});
  const [checkedTodaysData, setCheckedTodaysData] = React.useState(false);
  const [showPrientData, setshowPrientData] = useState(false);
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const patientListRecordLimit = 20;
  const maxValue = 1;
  const surgeryListFlag = true;
  const groupListFlag = true;
  const { headerSelectedPharmaciesFilter, loginUserDetail } = useSelector(
    (state) => state.user,
  );
  const [changeSurgeryDropDownValue, setChangeSurgeryDropDownValue] = useState(
    [],
  );
  const [changeGroupDropDownValue, setChangeGroupDropDownValue] = useState([]);
  const [openOrderNoteList, setOpenOrderNoteList] = useState(false);
  const [showOrderNoteList, setShowOrderNoteList] = useState({});
  const [confirmOpen, setConfirmOpen] = useState(false);
  const defaultColumnOrderBy = "asc";
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "",
  });
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const [openOrderMedicationDate, setOpenOrderMedicationDate] = useState(false);
  const [openConfirmEdit, setOpenConfirmEdit] = useState(false);
  const [clickOrderPlace, setClickOrderPlace] = useState(false);
  const daysMenuItems = [
    { index: 0, lable: "All orders" },
    { index: 1, lable: "Todays order" },
    { index: 2, lable: "Next 3 days order" },
    { index: 3, lable: "Next 7 days order" },
  ];

  const [item, setItem] = useState("all");
  const [ordergap, setOrdergap] = useState("");
  const query = new URLSearchParams(window.location.search);
  const [openEmailTemeplate, setOpenEmailTemeplate] = useState(false);
  const [openEmailTemplateId, setOpenEmailTemplateId] = useState({});
  const [selected, setSelected] = React.useState([]);
  const [limitWarning, setLimitWarning] = React.useState(false);
  const [openMultiOrderPopup, setOpenMultiOrderPopup] = React.useState(false);
  const [openSendEmailOrdersPopup, setOpenSendEmailOrdersPopup] = React.useState(false);
  const [openReviewRequired, setOpenReviewRequired] = useState(false);
  const [reviewRequiredPatient, setReviewRequiredPatient] = useState([]);
  const [openEarlyMultiOrder, setOpenEarlyMultiOrder] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [complianceStatus, setComplianceStatus] = useState(false);
  const [patientTypeStatus, setPatientTypeStatus] = useState([]);
  const [instalmentTypeStatus, setInstalmentTypeStatus] = useState([]);
  const [checkedAlert, setCheckedAlert] = React.useState(false);
  const [warningTypeStatus, setWarningTypeStatus] = useState([]);
  const [patientFilterTypeStatus, setPatientFilterTypeStatus] = useState([]);
  const [oosStatus, setOosStatus] = useState(
    query.get("oos") === "true"
  );
  const [dispenseTypeOpen, setDispenseTypeOpen] = useState(false);
  const [patientTypeOpen, setPatientTypeOpen] = useState(false);
  const [statusTypeOpen, setStatusTypeOpen] = useState(false);
  const [openCheckBoxColumn, setOpenCheckBoxColumn] = useState(false);
  const [detailsDialog, setDetailsDialog] = useState(false);
  const [showOrderMedicationDateDetails, setShowOrderMedicationDateDetails] =
    useState({});
  const showDataBasedOnRole = loginUserDetail?.data?.data?.role;
  const [patientDetails, setPatientDetails] = useState({});
  const [openTableColumn, setOpenTableColumn] = useState(false);
  const [openFilterPopup, setOpenFilterPopup] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  const [prnReview, setPrnReview] = useState(false);
  const [prnItem, setPRNitem] = useState({});
  const [orderPlace, setOrderPlace] = useState(false);
  const [orderItemList, setOrderItemList] = useState({});
  const [orderId, setOrderId] = useState({});
  const [isOrder, setisOrder] = useState(false);
  const [prnWarning, setPrnWarning] = useState(false);
  const [patientDetailOpen, setPatientDetailOpen] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [patientId, setPatientId] = useState("");
  const [cycleDialog, setCycleDialog] = useState("");
  const [warningOrderdate, setWarningOrderdate] = useState(false);
  const [clickOrder, setClickOrder] = useState(false);
  const [openPatientStatus, setOpenPatientStatus] = useState(false);
  const [patientStatus, setPatientStatus] = useState("");
  const [columnsPopperAnchorEl, setColumnsPopperAnchorEl] = useState(null);
  const activeColumns = useMemo(
    () => getLocalStorage("dynamicColumnRepeatOrder")?.split(",") || [],
    [],
  );
  const showLoaderValue = useMemo(
    () => Object.values(tableColumns).filter((item) => item),
    [tableColumns],
  );
  const columnSequence = useMemo(
    () => getLocalStorage("dynamicColumnSequenceRepeatOrder")?.split(",") || [],
    [],
  );
  const activeCurrentTableView =
    getLocalStorage("dynamicTableViewRepeatOrder") || "basic";
  const [currentTableView, setCurrentTableView] = useState(
    activeCurrentTableView,
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popperAnchorEl, setPopperAnchorEl] = React.useState(null);
  const [warningAnchorEl, setWarningAnchorEl] = React.useState(null);
  const [surgeryOpen, setSurgeryOpen] = useState(false);
  const [groupOpen, setGroupOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [firstChangeSurgery, setFirstChangeSurgery] = useState(true);
  const [firstChangeGroup, setFirstChangeGroup] = useState(true);
  const [orderCountPayload, setOrderCountPayload] = useState({});
  const [apiCall, setApiCall] = useState(false);
  const [countApiCall, setCountApiCall] = useState(false);
  const open = Boolean(anchorEl);
  const handleClickFilter = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleCloseFilter = () => {
    setAnchorEl(null);
  };

  const manageDispenseFilter = (newValue, type) => {
    if ("dispense" == type) {
      if (instalmentTypeStatus.includes(newValue)) {
        let tempData = instalmentTypeStatus.filter((item) => item != newValue);
        setInstalmentTypeStatus(tempData);
      } else {
        setInstalmentTypeStatus([...instalmentTypeStatus, newValue]);
      }
    }
    if ("patient" == type) {
      if (patientTypeStatus.includes(newValue)) {
        let tempData = patientTypeStatus.filter((item) => item != newValue);
        setPatientTypeStatus(tempData);
      } else {
        setPatientTypeStatus([...patientTypeStatus, newValue]);
      }
    }
    if ("status" === type) {
      if (patientFilterTypeStatus.includes(newValue)) {
        let tempData = patientFilterTypeStatus.filter(
          (item) => item != newValue,
        );
        setPatientFilterTypeStatus(tempData);
      } else {
        setPatientFilterTypeStatus([...patientFilterTypeStatus, newValue]);
      }
    }
  };

  const manageAlertFilter = (newValue, type) => {
    if ("alert" == type) {
      if (warningTypeStatus.includes(newValue)) {
        let tempData = warningTypeStatus.filter((item) => item != newValue);
        setWarningTypeStatus(tempData);
      } else {
        setWarningTypeStatus([...warningTypeStatus, newValue]);
      }
    }
  };

  useLayoutEffect(() => {
    localStorage.removeItem("groupList");
    localStorage.removeItem("surgeryList");
  }, []);

  /** get list  */
  const getList = (params = {}, skipBulkCount = false) => {
    let tempSurgeryList = getLocalStorage("surgeryList")
      ? Object.keys(JSON.parse(getLocalStorage("surgeryList")))
      : [];

    let tempGroupList = getLocalStorage("groupList")
      ? Object.keys(JSON.parse(getLocalStorage("groupList")))
      : [];

    let payload = {
      offset: 0,
      limit: patientListRecordLimit,
      q:
        // getLocalStorage("searchString")
        //   ? getLocalStorage("searchString")
        //   :
        searchValue,
      surgery_id:
        tempSurgeryList.length > 0
          ? tempSurgeryList
          : Object.keys(changeSurgeryDropDownValue),
      group_id:
        tempGroupList.length > 0
          ? tempGroupList
          : Object.keys(changeGroupDropDownValue),
      order_by: params.orderBy || columnSortingOrder.orderBy,
      sort_by: (params.sortBy || columnSortingOrder.sortBy).toUpperCase(),
      type: "all",
    };
    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }

    if (item) {
      payload.type = item;
    }

    if (query.get("orderDateMissmatch") === "true") {
      payload.order_gap_status = ["3"];
      setWarningTypeStatus(["3"]);
      payload.type = "all";
    }
    if (query.get("unassigned") === "true") {
      payload.type = "unassigned";
    }
    if (complianceStatus == true) {
      payload.compliance_aid = true;
    }
    if (patientTypeStatus.length > 0) {
      payload.patient_type = patientTypeStatus;
    }
    if (instalmentTypeStatus.length > 0) {
      payload.instalment_type = instalmentTypeStatus;
    }
    if (patientFilterTypeStatus.length > 0) {
      payload.patient_status = patientFilterTypeStatus;
    }
    if (warningTypeStatus.length > 0) {
      payload.order_gap_status = warningTypeStatus;
    }
    if (query.get("warnings") === "true") {
      payload.order_gap_status = ["2", "1"];
      setWarningTypeStatus(["2", "1"]);
    }
    if (oosStatus == true) {
      payload.is_oos = oosStatus;
    }
    payload = {
      ...payload,
      ...params,
    };
    getOrderListAction(getClearObject(payload));
    if (!skipBulkCount) {
      getBulkOrderCountAction();
    }
  };

  useLayoutEffect(() => {
    setLocalStorage("prnActive", false);
    let payload = {
      offset: 0,
      type: "all",
      limit: 20,
    };
    let tempSurgeryList = getLocalStorage("surgeryList")
      ? Object.keys(JSON.parse(getLocalStorage("surgeryList")))
      : [];

    let tempGroupList = getLocalStorage("groupList")
      ? Object.keys(JSON.parse(getLocalStorage("groupList")))
      : [];
    let payloadcount = {
      surgery_id:
        tempSurgeryList.length > 0
          ? tempSurgeryList
          : Object.keys(changeSurgeryDropDownValue),
      group_id:
        tempGroupList.length > 0
          ? tempGroupList
          : Object.keys(changeGroupDropDownValue),
    };

    if (getLocalStorage("prnActive") == "false") {
      navigate("/order");
    }

    if (selectedHeaderPharmacyId !== "" && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }

    const hasExistingData = repeatOrderList?.data?.list?.length > 0;
    const shouldRefreshAfterCreate =
      getLocalStorage("refreshRepeatOrderListOnReturn") == "true";

    if (shouldRefreshAfterCreate) {
      getOrderListAction(payload);
      // getBulkOrderCountAction();
      localStorage.removeItem("refreshRepeatOrderListOnReturn");
      return;
    }

    if (
      !hasExistingData &&
      selectedHeaderPharmacyId === "all" &&
      query.get("orderDateMissmatch") !== "true" &&
      query.get("unassigned") !== "true" &&
      query.get("warnings") !== "true" &&
      query.get("oos") !== "true"
    ) {
      getOrderListAction(payload);
      // getBulkOrderCountAction();
    }
    return () => {
      if (window.location.pathname !== "/order") {
        // getOrderListAction(payload);
        // window.onbeforeunload = null;
        // setLocalStorage("pharmacyChange", false);
        // setLocalStorage("groupList", {});
      }
    };
  }, []);

  useEffect(() => {
    let payload = {
      offset: 0,
      type: "all",
      limit: 20,
    };

    let tempSurgeryList = getLocalStorage("surgeryList")
      ? Object.keys(JSON.parse(getLocalStorage("surgeryList")))
      : [];

    let tempGroupList = getLocalStorage("groupList")
      ? Object.keys(JSON.parse(getLocalStorage("groupList")))
      : [];
    let payloadcount = {
      surgery_id:
        tempSurgeryList.length > 0
          ? tempSurgeryList
          : Object.keys(changeSurgeryDropDownValue),
      group_id:
        tempGroupList.length > 0
          ? tempGroupList
          : Object.keys(changeGroupDropDownValue),
    };

    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payloadcount.pharmacy_id = [selectedHeaderPharmacyId];
    }

    if (
      Object.keys(repeatOrderList?.data || {}).length === 0 &&
      repeatOrderList?.loading === false &&
      repeatOrderList?.success === false
    ) {
      getOrderListAction(payload);
      getBulkOrderCountAction();
    }
  }, [repeatOrderList.data]);

  useEffect(() => {
    if (query.get("orderDateMissmatch") === "true") {
      setItem("all");
    }
  }, [query.has("orderDateMissmatch")]);

  useEffect(() => {
    if (query.get("unassigned") === "true") {
      setItem("unassigned");
    }
  }, [query.has("unassigned")]);

  useEffect(() => {
    if (query.get("oos") === "true") {
      setOosStatus(true);
      setItem("all");
    }
  }, [query.get("oos")]);

  /** api call header Selected Pharmacies Filter */
  useEffect(() => {
    let payLoad = {};
    const hasExistingData = repeatOrderList?.data?.list?.length > 0;

    if (!repeatOrderList?.loading) {
      if (
        getLocalStorage("pharmacyChange") == "true" ||
        checked === true ||
        checkedAlert === true ||
        openTableColumn === true ||
        query.has("unassigned") ||
        query.has("orderDateMissmatch") ||
        query.has("warnings") ||
        query.has("oos") ||
        (!hasExistingData && selectedHeaderPharmacyId !== "all")
      ) {
        let payload = {};
        if (
          getLocalStorage("pharmacyChange") == "true" &&
          selectedHeaderPharmacyId === "all"
        ) {
          // For pharmacy header
          getList(payload);
          setApiCall(true);
        } else {
          if (query.get("oos") === "true") {
            payLoad = {
              type: "all",
              is_oos: true,
              pharmacy_id: [selectedHeaderPharmacyId],
            };
          } else {
            payLoad = {
              pharmacy_id: [selectedHeaderPharmacyId],
            };
          }
          if (query.get("dashboard") === "true") {
            navigate("/order");
            getList(payLoad);
            setApiCall(true);
          } else {
            getList(payLoad, true);
            setApiCall(true);
          }
        }
      }
    } else {
      if (!apiCall) {
        if (
          getLocalStorage("oos_filter") != "true" &&
          selectedHeaderPharmacyId !== "all"
        ) {
          setApiCall(true);
        }
      }
    }
  }, [
    selectedHeaderPharmacyId,
    query.has("unassigned"),
    query.has("orderDateMissmatch"),
    query.has("warnings"),
    query.get("oos"),
    globalSetting,
    complianceStatus,
    patientTypeStatus,
    instalmentTypeStatus,
    patientFilterTypeStatus,
    warningTypeStatus,
    oosStatus,
    apiCall,
  ]);
  useEffect(() => {
    let tempSurgeryList = getLocalStorage("surgeryList")
      ? Object.keys(JSON.parse(getLocalStorage("surgeryList")))
      : [];

    let tempGroupList = getLocalStorage("groupList")
      ? Object.keys(JSON.parse(getLocalStorage("groupList")))
      : [];
    let payloadcount = {
      surgery_id:
        tempSurgeryList.length > 0
          ? tempSurgeryList
          : Object.keys(changeSurgeryDropDownValue),
      group_id:
        tempGroupList.length > 0
          ? tempGroupList
          : Object.keys(changeGroupDropDownValue),
    };
    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payloadcount.pharmacy_id = [selectedHeaderPharmacyId];
    }
    if (
      selectedHeaderPharmacyId !== "" &&
      selectedHeaderPharmacyId !== null &&
      !countApiCall &&
      getLocalStorage("pharmacyChange") === "false"
    ) {
      getOrderCountTypeAction(payloadcount);
      setOrderCountPayload(payloadcount);
      setCountApiCall(true);
    }
    if (
      selectedHeaderPharmacyId !== "" &&
      selectedHeaderPharmacyId !== null &&
      getLocalStorage("pharmacyChange") === "true"
    ) {
      getOrderCountTypeAction(payloadcount);
      setOrderCountPayload(payloadcount);
    }
    if (Object.keys(changeSurgeryDropDownValue).length > 0) {
      getOrderCountTypeAction(payloadcount);
      setOrderCountPayload(payloadcount);
    }
    if (Object.keys(changeGroupDropDownValue).length > 0) {
      getOrderCountTypeAction(payloadcount);
      setOrderCountPayload(payloadcount);
    }
  }, [
    selectedHeaderPharmacyId,
    changeGroupDropDownValue,
    changeSurgeryDropDownValue,
  ]);

  useEffect(() => {
    if (columnSortingOrder.orderBy && columnSortingOrder.sortBy) {
      console.log("get list 4");
      getList();
    }
  }, [columnSortingOrder.orderBy, columnSortingOrder.sortBy]);

  /** api call repeat Order List*/
  useEffect(() => {
    if (entry.isIntersecting) {
      if (query.has("unassigned")) {
        navigate("/order");
        if (
          repeatOrderList?.data?.list?.length !=
          repeatOrderList?.data?.filterd_record
        ) {
          getList({
            offset: repeatOrderList?.data?.list?.length,
            limit: patientListRecordLimit,
            order_by: columnSortingOrder.orderBy,
            sort_by: columnSortingOrder.sortBy.toUpperCase(),
            type: "unassigned",
          }, true);
          return;
        }
      }
      if (query.has("orderDateMissmatch")) {
        navigate("/order");
        manageAlertFilter("3", "alert");
      }
      if (query.has("warnings")) {
        navigate("/order");
        manageAlertFilter("2", "alert");
      }
      if (
        repeatOrderList?.data?.list?.length !=
        repeatOrderList?.data?.filterd_record
      ) {
        getList({
          offset: repeatOrderList?.data?.list?.length,
          limit: patientListRecordLimit,
          order_by: columnSortingOrder.orderBy,
          sort_by: columnSortingOrder.sortBy.toUpperCase(),
        }, true);
      }
    }
  }, [
    entry,
    query.has("unassigned"),
    query.has("orderDateMissmatch"),
    query.has("warnings"),
  ]);

  /** search user debounce */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      setLocalStorage("searchString", searchString);
      getList(
        {
          ...(searchString && {
            q: searchString,
          }),
          ...otherStateValues,
        },
        true, // skipBulkCount — do not call getBulkOrderCountAction on search
      );
    }, 500),
  );

  /** handle search */
  const handleSearch = (newValue) => {
    setLocalStorage("searchString", newValue);
    let payLoad = {};
    let filterType = "all";
    if (item) {
      filterType = item;
    }

    if (complianceStatus === true) {
      payLoad.compliance_aid = true;
    }
    if (patientTypeStatus.length > 0) {
      payLoad.patient_type = patientTypeStatus;
    }
    if (instalmentTypeStatus.length > 0) {
      payLoad.instalment_type = instalmentTypeStatus;
    }
    if (patientFilterTypeStatus.length > 0) {
      payLoad.patient_status = patientFilterTypeStatus;
    }
    if (warningTypeStatus.length > 0) {
      payLoad.order_gap_status = warningTypeStatus;
    }
    if (oosStatus === true) {
      payLoad.is_oos = oosStatus;
    }

    searchUserDebounce.current(newValue, {
      today_order: checkedTodaysData,
      surgery_id: Object.keys(changeSurgeryDropDownValue),
      group_id: Object.keys(changeGroupDropDownValue),
      pharmacy_id:
        selectedHeaderPharmacyId !== "all" ? [selectedHeaderPharmacyId] : [],
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
      type: filterType,
      is_oos: oosStatus,
      order_gap_status: warningTypeStatus,
      patient_status: patientFilterTypeStatus,
      instalment_type: instalmentTypeStatus,
      patient_type: patientTypeStatus,
      compliance_aid: complianceStatus,
    });
  };

  /** handle Delete Repeat Order*/
  const handleDeleteRepeatOrder = () => {
    let payLoad = {
      offset: 0,
    };
    let payload = {};
    deleteRepeatOrderAction(patientDeleteId);
    getPatientListAction(payLoad);
    getHomeListAction(payload);
    // }
  };

  /** handle Select Todays Order */
  const handleSelectTodaysOrder = (e) => {
    setItem(e.target.value);

    if (query.get("orderDateMissmatch") === "true") {
      getList({
        type: e.target.value,
        is_bigger_order_date: true,
      });
    } else {
      getList({
        type: e.target.value,
      });
    }
  };

  /** handle Surgery Change */
  const handleSureryChange = (value) => {
    let tempGroupList = getLocalStorage("groupList")
      ? Object.keys(JSON.parse(getLocalStorage("groupList")))
      : [];
    if (Object.keys(value).length == 0) {
      setFilterCount((prevCount) => prevCount - 1);
      setFirstChangeSurgery(true);
    }
    if (firstChangeSurgery) {
      if (Object.keys(value).length == 1) {
        setFilterCount((prevCount) => prevCount + 1);
      }
      setFirstChangeSurgery(false);
    }
    setChangeSurgeryDropDownValue(value);
    setLocalStorage("surgeryList", value);
    let payloadcount = {
      group_id:
        tempGroupList.length > 0
          ? tempGroupList
          : Object.keys(changeGroupDropDownValue),
    };
    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payloadcount.pharmacy_id = [selectedHeaderPharmacyId];
    }
    getList({
      surgery_id: Object.keys(value),
    });
    if (Object.keys(value).length === 0) {
      getOrderCountTypeAction(payloadcount);
      setOrderCountPayload(payloadcount);
    }
  };

  /** handle Group Change */
  const handleGroupChange = (value) => {
    let tempSurgeryList = getLocalStorage("surgeryList")
      ? Object.keys(JSON.parse(getLocalStorage("surgeryList")))
      : [];

    if (Object.keys(value).length == 0) {
      setFilterCount((prevCount) => prevCount - 1);
      setFirstChangeGroup(true);
    }
    if (firstChangeGroup) {
      if (Object.keys(value).length == 1) {
        setFilterCount((prevCount) => prevCount + 1);
      }
      setFirstChangeGroup(false);
    }
    setChangeGroupDropDownValue(value);
    setLocalStorage("groupList", value);
    let payloadcount = {
      surgery_id:
        tempSurgeryList.length > 0
          ? tempSurgeryList
          : Object.keys(changeSurgeryDropDownValue),
    };
    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      payloadcount.pharmacy_id = [selectedHeaderPharmacyId];
    }
    getList({
      group_id: Object.keys(value),
    });
    if (Object.keys(value).length === 0) {
      getOrderCountTypeAction(payloadcount);
      setOrderCountPayload(payloadcount);
    }
  };

  /** set data useEffect */
  useEffect(() => {
    if (
      !deleteRepeatOrder?.loading &&
      Object.keys(deleteRepeatOrder?.data)?.length
    ) {
      setDeletePatient(false);
      setPatientDeleteId("");
      resetOrderState("deleteRepeatOrder", "");
      getHomeListAction();
    }
  }, [deleteRepeatOrder]);

  /** get print repeat order */
  const handelGetRepeatOrderPrintData = (data) => {
    let payload = {
      offset: 0,
      limit: patientListRecordLimit,
      q: searchValue,
      today_order: checkedTodaysData,
      surgery_id: Object.keys(changeSurgeryDropDownValue),
      group_id: Object.keys(changeGroupDropDownValue),
      all_record: true,
    };
    if (item) {
      payload.type = item;
    }

    if (selectedHeaderPharmacyId != "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
    }
    setshowPrientData(true);
    getPrintOrderListAction(getClearObject(payload));
  };

  /** print repeat order function */
  const printRepearOrderAction = () => {
    let printContents = document.getElementById("print-order-data").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    window.close();
    document.body.innerHTML = originalContents;
    document.getElementById("print-order-data").remove();
  };

  window.addEventListener("afterprint", (event) => {
    if (showPrientData === true) {
      setshowPrientData(false);
      resetOrderState("printRepeatOrderList", { loading: false, data: [] });
      window.location.reload();
    }
  });

  /** Print Api call useEffect */
  useEffect(() => {
    if (printRepeatOrderList.data?.length > 0) {
      printRepearOrderAction();
    }
  }, [printRepeatOrderList.data]);

  const handleConfirmSubmit = () => {
    if (showOrderNoteList?.order_notes) {
      setOpenOrderNoteList(true);
    } else {
      navigate(
        `/order?orderMethod=order-pad&actionType=repeatOrderPage&orderId=${showOrderNoteList?.id}&patient_id=${showOrderNoteList?.patient_id}`,
      );
    }
  };

  /* Single Handle Click Tick Action */
  const handleClickTickAction = useCallback((event, item) => {
    if (
      !(
        item?.status === "Absent" ||
        item?.status === "In-Hospital" ||
        (item?.order_type === "slow" && !item?.is_review_prn)
      )
    ) {
      const selectedIndex = selected.indexOf(item);
      let newSelected = [];
      //If record not found then add
      let openModals = false;
      if (selectedIndex === -1) {
        // Enforce 100-order limit
        const currentValidCount = selected.filter((s) => s?.id).length;
        if (currentValidCount >= 100) {
          setLimitWarning(true);
          return;
        }
        openModals = true;
        newSelected = newSelected.concat(selected, item);
        setLimitWarning(false);
        //If record present then remove
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
        setLimitWarning(false);
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
        setLimitWarning(false);
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
        );
        setLimitWarning(false);
      }
      setSelected(newSelected);
      setReviewRequiredPatient(newSelected);
    }
  }, [selected]);

  /**applied filter in the icon  */
  const handleIconFilterChange = (e) => {
    setPopperAnchorEl(e.currentTarget);
    setChecked((prev) => !prev);
  };

  /**applied filter on change in the warning  */
  const handleWarningChange = (e) => {
    setWarningAnchorEl(e.currentTarget);
    setCheckedAlert((prev) => !prev);
  };

  /* Multiple Handle Change Action */
  const handleChangeAction = (e) => {
    if (e.target.checked) {
      const eligibleItems = repeatOrderList?.data?.list
        .filter((item) => {
          return !(
            item?.status === "Absent" ||
            item?.status === "In-Hospital" ||
            (item?.order_type === "slow" && !item?.is_review_prn)
          );
        });

      // Enforce 100-order limit on select all
      const cappedItems = eligibleItems.slice(0, 100);
      if (eligibleItems.length > 100) {
        setLimitWarning(true);
      } else {
        setLimitWarning(false);
      }

      // Build newSelected preserving {} for ineligible items (keeps index alignment)
      const newSelected = repeatOrderList?.data?.list.map((item) => {
        const isEligible = !(
          item?.status === "Absent" ||
          item?.status === "In-Hospital" ||
          (item?.order_type === "slow" && !item?.is_review_prn)
        );
        if (!isEligible) return {};
        return cappedItems.includes(item) ? item : {};
      });
      setSelected(newSelected);
      return;
    }
    setLimitWarning(false);
    setSelected([]);
  };

  const showEarlyOrderData = selected.some(
    ({ is_early_order }) => is_early_order === true,
  );

  /**handle click Away in filter dropdown */
  const handleClickAway = () => {
    setCheckedAlert(false);
    setChecked(false);
  };
  const handleType = (type) => {
    if (type === "patient") {
      setPatientTypeOpen(!patientTypeOpen);
    }
    if (type === "dispense") {
      setDispenseTypeOpen(!dispenseTypeOpen);
    }
    if (type === "status") {
      setStatusTypeOpen(!statusTypeOpen);
    }
  };

  const showCountForMultiOrder = selected.filter((item) => item?.id);

  //Set value after page refresh useEffect
  useLayoutEffect(() => {
    let allColumns =
      ["pharmacist_staff", "pharmacy"].indexOf(showDataBasedOnRole) !== -1
        ? tableCellsPharmacy
        : tableCells;

    if (activeColumns.length > 0) {
      Object.keys(allColumns)?.map((key) => {
        if (allColumns[key].showValue) {
          if (activeColumns.indexOf(allColumns[key].id) !== -1) {
            allColumns[key].show = true;
          } else {
            allColumns[key].show = false;
          }
        }
      });
    }
    allColumns = getNewOrder(columnSequence, allColumns);
    setTableColumns(allColumns);
  }, []);

  const handleMediArchive = (id) => {
    let historyPayload = { offset: 0, limit: 20 };
    getMedicationArchiveAction(id);
    setIsArchive(true);
  };
  useEffect(() => {
    if (archiveMedi?.data?.success && isArchive) {
      getPatientHistoryAction(patientId, {
        offset: 0,
        limit: 20,
      });
      setIsArchive(false);
    }
  }, [archiveMedi?.data?.success]);

  useEffect(() => {
    setLocalStorage("oos_filter", "false");
  }, []);
  const handleSurgeryopen = () => {
    setSurgeryOpen(!surgeryOpen);
  };
  const handleGroupopen = () => {
    setGroupOpen(!groupOpen);
  };
  const handleClickFilterClear = () => {
    setChangeSurgeryDropDownValue([]);
    setLocalStorage("surgeryList", {});
    setChangeGroupDropDownValue([]);
    setLocalStorage("groupList", {});
    setFilterCount(0);
    setFirstChangeSurgery(true);
    setFirstChangeGroup(true);
    let payload = {
      offset: 0,
      limit: 20,
      type: "all",
    };
    let payloadcount = {};
    if (selectedHeaderPharmacyId !== "" && selectedHeaderPharmacyId !== "all") {
      payload.pharmacy_id = [selectedHeaderPharmacyId];
      payloadcount.pharmacy_id = [selectedHeaderPharmacyId];
    }
    if (searchValue !== "") {
      payload.q = searchValue;
    }
    getOrderListAction(payload);
    getBulkOrderCountAction();
    getOrderCountTypeAction(payloadcount);
    setOrderCountPayload(payloadcount);
  };

  useEffect(() => {
    let payload = {
      offset: 0,
      limit: 20,
      type: "all",
    };
    const storedSurgeryList = JSON.parse(getLocalStorage("surgeryList"));
    const storedGroupList = JSON.parse(getLocalStorage("groupList"));
    if (storedSurgeryList && Object.keys(storedSurgeryList).length > 0) {
      // setFilterCount((prevCount) => prevCount + 1);
      payload.surgery_id = Object.keys(storedSurgeryList);
    }
    if (storedGroupList && Object.keys(storedGroupList).length > 0) {
      // setFilterCount((prevCount) => prevCount + 1);
      payload.group_id = Object.keys(storedGroupList);
    }
    if (
      (storedGroupList && Object.keys(storedGroupList).length > 0) ||
      (storedSurgeryList && Object.keys(storedSurgeryList).length > 0)
    ) {
      // getOrderListAction(payload);
    }
    getBulkOrderCountAction();
  }, []);

  const handleSendBuildOrderDailog = () => {
    getBulkOrderListAction();
    setOpenSendEmailOrdersPopup(true);
  }

  return (
    <>
      <Grid className={classes.rsMainMarign}>
        <Grid className={classes.reRepeatOrderCheckBox} container>
          <FormGroup className={classes.todaysOrderStyle}>
            <Select
              value={item}
              className={classes.dayAutocomplete}
              onChange={handleSelectTodaysOrder}
              sx={{
                height: 40,
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
            >
              {orderCountTypeList?.data?.data?.map((name, index) => (
                <MenuItem
                  key={index}
                  value={name.key}
                  name={name.label}
                  className={name?.key == "unassigned" ? classes.redtext : ""}
                >
                  {parse(sanitizeHtml(name.label))}
                  {` (${name?.value})`}
                </MenuItem>
              ))}
            </Select>
            {/* {width > 500 && ( */}
            <HtmlTooltipMain title="" className="hoverAlign">
              {/* <IconButton
                className={classes.rsButtonHowtoIcon}
                variant="contained"
                startIcon={
                  <PrimaryIcon
                    icon={AddIcon}
                    color="white"
                    width="16px"
                    height="16px"
                  />
                }
                onClick={() => {
                  navigate("/order?actionType=create");
                }}
              >
                <PrimaryIcon width="20px" icon={EventIcon} cursor="pointer" />
              </IconButton> */}
              <Button
                variant="contained"
                className={classes.rsButtonHowtoIcon}
                sx={{
                  marginLeft: "10px !important",
                }}
                startIcon={
                  <PrimaryIcon
                    icon={AddIcon}
                    color="white"
                    width="16px"
                    height="16px"
                  />
                }
                onClick={() => {
                  navigate("/order?actionType=create");
                }}
              >
                Create Order
              </Button>
            </HtmlTooltipMain>
            {
              orderCountOfBulkOrder?.data?.today_order_count > 0 && (
                <Box display={"flex"} alignItems={"center !important"} width={'auto'} gap={'5px'}>
                  <HtmlTooltipMain title="Send Email Orders">
                    <Button
                      variant="contained"
                      className={classes.rsButtonEmailIcon}
                      sx={{
                        marginLeft: "0px !important",
                      }}
                      startIcon={
                        <PrimaryIcon
                          icon={EmailOutlinedIcon}
                          width="25px"
                          height="25px"
                          color="white"
                        />
                      }
                      onClick={() => handleSendBuildOrderDailog()}
                    >
                      Send Email Orders {`(${orderCountOfBulkOrder?.data?.today_order_count || 0})`}
                    </Button>
                  </HtmlTooltipMain>
                  <HtmlTooltipMain
                    title={
                      <Box>
                        <Box sx={{ fontWeight: 600, mb: 0.5 }}>Bulk Order Emails</Box>
                        <Box>
                          This shows the total number of patients who have orders due today and are eligible to receive an automated email notification. Clicking the button opens a dialog where you can review and send email notifications for all pending bulk orders.
                        </Box>
                      </Box>
                    }
                  >
                    <IconButton
                      className={classes.rsButtonHelpIcon}
                    >
                      <InfoOutlinedIcon />
                    </IconButton>
                  </HtmlTooltipMain>
                </Box>
              )
            }
            {/* )} */}
            {/* {width > 1300 && (
                <HtmlTooltip title="Print">
                  <Box className={classes.rsprintButton}>
                    <Button
                      className={classes.printButton}
                      variant="outlined"
                      disabled={printRepeatOrderList?.loading}
                      onClick={() => {
                        handelGetRepeatOrderPrintData();
                      }}
                    >
                      <PrimaryIcon
                        icon={printIcon}
                        color="primary"
                        width="25px"
                        height="25px"
                      />
                    </Button>
                  </Box>
                </HtmlTooltip>
              )} */}
          </FormGroup>
          {/* {width <= 500 && (
            <Button
              variant="contained"
              startIcon={
                <PrimaryIcon
                  icon={AddIcon}
                  color="white"
                  width="16px"
                  height="16px"
                />
              }
              onClick={() => {
                navigate("/order?actionType=create");
              }}
            >
              Create Order
            </Button>
          )} */}

          {/* {width <= 500 && (
            <Box className="ColumnMain">
              <HtmlTooltip title="Columns">
                <Box>
                  <Button
                    className="ColumnBtn"
                    onClick={() => {
                      setIsOrderRecordActionType("orderDetails");
                      setOpenTableColumn(true);
                    }}
                  >
                    <PrimaryIcon
                      color="black"
                      width="20px"
                      icon={ViewWeekIcon}
                      cursor="pointer"
                    />
                    Columns
                    <PrimaryIcon
                      color="black"
                      width="30px"
                      icon={ArrowDropDownIcon}
                      cursor="pointer"
                    />
                  </Button>
                </Box>
              </HtmlTooltip>
            </Box>
          )} */}

          <Grid className={classes.rsPatientHeader}>
            {/* {width > 1450 && (
              <SurgeryAutoComplete
                fullWidth
                multiple
                maxValue={maxValue}
                surgeryListFlag={surgeryListFlag}
                className={classes.autoCompleteBox}
                value={changeSurgeryDropDownValue}
                handleChange={(value) => handleSureryChange(value)}
                renderInput={(params) => (
                  <TextField {...params} label="Surgeries" />
                )}
              />
            )}
            {width > 1450 && (
              <GroupAutoComplete
                fullWidth
                multiple
                className={classes.autoCompleteBox}
                maxValue={maxValue}
                groupListFlag={groupListFlag}
                value={changeGroupDropDownValue}
                handleChange={(value) => handleGroupChange(value)}
                renderInput={(params) => (
                  <TextField {...params} label="Group List" />
                )}
              />
            )} */}
            <TextField
              className={classes.search}
              withPadding={true}
              medium
              secondary
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e?.target?.value);
                handleSearch(e?.target?.value);
              }}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <PrimaryIcon width="20px" icon={SearchIcon} />
                    </InputAdornment>
                  </>
                ),
              }}
            />
            {width > 1300 && (
              <Box className={classes.rsiconBtnForFilter}>
                <Box>
                  <IconButton onClick={handleClickFilter}>
                    <FilterListIcon />
                    <Box paddingRight={"5px"}>
                      {filterCount > 0 && filterCount}
                    </Box>
                    Filter
                  </IconButton>
                  {filterCount > 0 && (
                    <IconButton onClick={handleClickFilterClear}>
                      <ModalCloseIcon />
                    </IconButton>
                  )}
                </Box>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCloseFilter}
                  PaperProps={{
                    style: {
                      padding: "10px",
                      // maxHeight: ITEM_HEIGHT * 4.5,
                      width: "32ch",
                      marginTop: "10px",
                    },
                  }}
                >
                  <li
                    className={classes.rsCursor}
                    onClick={() => handleSurgeryopen()}
                  >
                    <Box className={classes.rsListAlignment}>
                      <Box>
                        Surgeries
                        {Object.keys(changeSurgeryDropDownValue).length !==
                          0 && <Box className={classes.rsActiveBtn}></Box>}
                      </Box>
                      <PrimaryIcon
                        width="20px"
                        height="20px"
                        icon={
                          surgeryOpen
                            ? KeyboardArrowUpOutlinedIcon
                            : KeyboardArrowDownOutlinedIcon
                        }
                      />
                    </Box>
                  </li>
                  <Collapse in={surgeryOpen}>
                    <ul className={classes.rsWaringFilterlistview}>
                      <li>
                        <SurgeryAutoComplete
                          fullWidth
                          multiple
                          maxValue={maxValue}
                          surgeryListFlag={surgeryListFlag}
                          className={clsx(
                            "autoCompleteBox",
                            classes.rsSurgeryAutoCompleteWebOther,
                          )}
                          value={changeSurgeryDropDownValue}
                          handleChange={(value) => handleSureryChange(value)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search Surgery"
                            />
                          )}
                        />
                      </li>
                    </ul>
                  </Collapse>
                  <hr />
                  <li
                    className={classes.rsCursor}
                    onClick={() => handleGroupopen()}
                  >
                    <Box className={classes.rsListAlignment}>
                      <Box>
                        Group List
                        {Object.keys(changeGroupDropDownValue).length !== 0 && (
                          <Box className={classes.rsActiveBtn}></Box>
                        )}
                      </Box>
                      <PrimaryIcon
                        width="20px"
                        height="20px"
                        icon={
                          groupOpen
                            ? KeyboardArrowUpOutlinedIcon
                            : KeyboardArrowDownOutlinedIcon
                        }
                      />
                    </Box>
                  </li>
                  <Collapse in={groupOpen}>
                    <ul className={classes.rsWaringFilterlistview}>
                      <li>
                        <GroupAutoComplete
                          fullWidth
                          multiple
                          className={clsx(
                            "autoCompleteBox",
                            classes.rsSurgeryAutoComplete,
                          )}
                          maxValue={maxValue}
                          groupListFlag={groupListFlag}
                          value={changeGroupDropDownValue}
                          handleChange={(value) => handleGroupChange(value)}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Search Group" />
                          )}
                        />
                      </li>
                    </ul>
                  </Collapse>
                  <hr />
                </Menu>
              </Box>
            )}
            {width > 1343 && (
              <HtmlTooltip title="Print">
                <Box className={classes.rsprintButton}>
                  <Button
                    className={classes.printButton}
                    variant="contained"
                    disabled={printRepeatOrderList?.loading}
                    onClick={() => {
                      handelGetRepeatOrderPrintData();
                    }}
                  >
                    <PrimaryIcon
                      icon={printIcon}
                      color="primary"
                      width="25px"
                      height="25px"
                    />
                  </Button>
                </Box>
              </HtmlTooltip>
            )}

            {/* {width > 500 && ( */}
            <Box
              className="ColumnMain"
              onClick={(e) => {
                setColumnsPopperAnchorEl(e.currentTarget);
                setIsOrderRecordActionType("orderDetails");
                setOpenTableColumn(true);
              }}
            >
              <HtmlTooltip title="Columns">
                <Box>
                  <Button
                    className="ColumnBtn"
                  // onClick={(e) => {
                  //   setColumnsPopperAnchorEl(e.currentTarget);
                  //   setIsOrderRecordActionType("orderDetails");
                  //   setOpenTableColumn(true);
                  // }}
                  >
                    <PrimaryIcon
                      color="black"
                      width="20px"
                      icon={ViewWeekIcon}
                      cursor="pointer"
                    />
                    Columns
                    <PrimaryIcon
                      color="black"
                      width="30px"
                      icon={ArrowDropDownIcon}
                      cursor="pointer"
                    />
                  </Button>
                </Box>
              </HtmlTooltip>
            </Box>
            {/* )} */}
            {width <= 1300 && (
              <Box className={classes.reRepeatOrderMobileIcon}>
                <HtmlTooltip title="Print">
                  <Box className={classes.rsprintButton}>
                    <Button
                      className={classes.printButton}
                      variant="outlined"
                      disabled={printRepeatOrderList?.loading}
                      onClick={() => {
                        handelGetRepeatOrderPrintData();
                      }}
                    >
                      <PrimaryIcon
                        icon={printIcon}
                        color="primary"
                        width="25px"
                        height="25px"
                      />
                    </Button>
                  </Box>
                </HtmlTooltip>
                <HtmlTooltip title="Filter">
                  <Box className={classes.rsFilterIconUnCollectedOther}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setOpenFilterPopup(true);
                      }}
                    >
                      <PrimaryIcon
                        color="primary"
                        width="20px"
                        height="37px"
                        icon={FilterIcon}
                      />
                    </Button>
                  </Box>
                </HtmlTooltip>
              </Box>
            )}
            {/* <Box className="RsSetting">
              <HtmlTooltip title="Setting">
                <Box className={classes.rsSetting}>
                  <PrimaryIcon
                    color="secondary"
                    className={classes.globalSettingIcon}
                    width="20px"
                    icon={SettingIcon}
                    cursor="pointer"
                    onClick={() => {
                      setIsOrderRecordActionType("orderDetails");
                      setOpenTableColumn(true);
                    }}
                  />
                </Box>
              </HtmlTooltip>
            </Box> */}
          </Grid>

          {/* <Grid></Grid> */}
        </Grid>
        {/* {width <= 1450 && (
          <Box className={classes.reRepeatOrderMobile}>
            <SurgeryAutoComplete
              fullWidth
              multiple
              maxValue={maxValue}
              surgeryListFlag={surgeryListFlag}
              className={classes.autoCompleteBox}
              value={changeSurgeryDropDownValue}
              handleChange={(value) => handleSureryChange(value)}
              renderInput={(params) => (
                <TextField {...params} label="Surgeries" />
              )}
            />
            <GroupAutoComplete
              fullWidth
              multiple
              className={classes.autoCompleteBox}
              maxValue={maxValue}
              groupListFlag={groupListFlag}
              value={changeGroupDropDownValue}
              handleChange={(value) => handleGroupChange(value)}
              renderInput={(params) => (
                <TextField {...params} label="Group List" />
              )}
            />
          </Box>
        )} */}

        <Grid>
          <Grid className={classes.GlobalSettingAndDays}>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* {selected.filter((item) => item?.id).length > 0 ? (
                <Button
                  className={classes.rsMultiOrderBtn}
                  variant="outlined"
                  startIcon={
                    <PrimaryIcon
                      icon={ordersIcon}
                      color="primary"
                      width="16px"
                      height="16px"
                    />
                  }
                  onClick={() => {
                    setSelected([...selected]);
                    if (showEarlyOrderData) {
                      setOpenEarlyMultiOrder(true);
                    } else {
                      setOpenMultiOrderPopup(true);
                    }
                  }}
                >
                  Place Order ({showCountForMultiOrder.length})
                </Button>
              ) : (
                <Button
                  className={classes.rsMultiOrderBtn}
                  variant={openCheckBoxColumn ? "contained" : "outlined"}
                  onClick={() => {
                    let isChecked = !openCheckBoxColumn;
                    setOpenCheckBoxColumn(isChecked);
                    if (!openCheckBoxColumn) {
                      setSelected([]);
                    }
                  }}
                >
                  Multi Order
                </Button>
              )} */}
              {/* <HtmlTooltip title="Filter">
                <Box>
                  <Button
                    className={classes.rsFilterIconUnCollectedOther}
                    variant="outlined"
                    onClick={() => {
                      setOpenFilterPopup(true);
                    }}
                  >
                    <PrimaryIcon
                      color="primary"
                      width="20px"
                      height="37px"
                      icon={FilterIcon}
                    />
                  </Button>
                </Box>
              </HtmlTooltip>
              <HtmlTooltip title="Settings">
                {width < 1600 && (
                  <HtmlTooltip title="Settings">
                    <Box>
                      <Button
                        className={classes.rsSettingMob}
                        variant="outlined"
                        onClick={() => {
                          setIsOrderRecordActionType("orderDetails");
                          setOpenTableColumn(true);
                        }}
                      >
                        <PrimaryIcon
                          color="primary"
                          width="20px"
                          icon={SettingIcon}
                          cursor="pointer"
                        />
                      </Button>
                    </Box>
                  </HtmlTooltip>
                )}
              </HtmlTooltip> */}

              {/* {width > 1599 && (
                <HtmlTooltip title="Settings">
                  <Box>
                    <PrimaryIcon
                      color="secondary"
                      className={classes.globalSettingIcon}
                      width="20px"
                      icon={SettingIcon}
                      cursor="pointer"
                      onClick={() => {
                        setIsOrderRecordActionType("orderDetails");
                        setOpenTableColumn(true);
                      }}
                    />
                  </Box>
                </HtmlTooltip>
              )} */}
            </Box>
          </Grid>
        </Grid>
        <Grid className={classes.rsGrid}>
          <Grid
            className={clsx(
              "common-table",
              width < 1100
                ? classes.managePageMobile
                : openCheckBoxColumn
                  ? classes.manageOpenCheckBox
                  : currentTableView === "advance"
                    ? classes.tableViewManage
                    : item == "inactive"
                      ? classes.tableViewManage
                      : classes.managePageH,
            )}
          >
            <TableContainer>
              <Table stickyHeader>
                <TableHead className={clsx(classes.tableHead)}>
                  <TableRow>
                    {openCheckBoxColumn && (
                      <TableCell>
                        <FormControlLabel
                          className={classes.labelWhiteSpaceNW}
                          checked={
                            repeatOrderList?.data?.list?.length > 0 &&
                            selected?.length ===
                            repeatOrderList?.data?.list?.length
                          }
                          onChange={handleChangeAction}
                          control={<Checkbox color="primary" />}
                        />
                      </TableCell>
                    )}
                    {Object.keys(tableColumns).map((headCell) => (
                      <>
                        {tableColumns[headCell].show && (
                          <>
                            {tableColumns[headCell].sortable === true ? (
                              <TableCell
                                className={
                                  tableColumns[headCell]?.label === "PATIENT" &&
                                    openCheckBoxColumn === false
                                    ? "table-patient"
                                    : ""
                                }
                                key={headCell.id}
                                align="center"
                                padding={
                                  tableColumns[headCell].disablePadding
                                    ? "none"
                                    : "normal"
                                }
                              >
                                <Box className={classes.rsTableCellHeader}>
                                  <TableSortLabel
                                    sx={{
                                      "&.MuiTableSortLabel-root": {
                                        color: "white",
                                      },
                                      "& .MuiTableSortLabel-icon": {
                                        color:
                                          columnSortingOrder.orderBy ===
                                            tableColumns[headCell].id
                                            ? "#525252 !important"
                                            : "#C5C5C5 !important",
                                        "&.MuiTableSortLabel-iconDirectionDesc":
                                        {
                                          color: "#525252 !important",
                                        },
                                        "& .MuiTableSortLabel-iconDirectionAsc":
                                        {
                                          color:
                                            columnSortingOrder.orderBy ===
                                              tableColumns[headCell].id
                                              ? "#525252 !important"
                                              : "#C5C5C5 !important",
                                        },
                                      },
                                    }}
                                    className="tableSort"
                                    direction={
                                      columnSortingOrder.orderBy ===
                                        tableColumns[headCell].id
                                        ? columnSortingOrder.sortBy
                                        : defaultColumnOrderBy
                                    }
                                    onClick={(e) => {
                                      setColumnSortingOrder({
                                        orderBy: tableColumns[headCell].id,
                                        sortBy:
                                          (columnSortingOrder.orderBy ===
                                            tableColumns[headCell].id
                                            ? columnSortingOrder.sortBy
                                            : defaultColumnOrderBy) === "desc"
                                            ? "asc"
                                            : "desc",
                                      });
                                    }}
                                  >
                                    {tableColumns[headCell].label}
                                  </TableSortLabel>

                                  {tableColumns[headCell].icons === true &&
                                    (tableColumns[headCell].apply === true ? (
                                      <Box className={classes.rsWaringList}>
                                        {/* {tableColumns[headCell].label} */}
                                        {/* <Box className={classes.rsWaringList}> */}
                                        <Box
                                          className={classes.rsIconBtnWarning}
                                        >
                                          <FilterListIcon
                                            className={classes.rsWaringCursor}
                                            onClick={(e) =>
                                              handleWarningChange(e)
                                            }
                                          />
                                          {warningTypeStatus?.length > 0 && (
                                            <Box
                                              className={
                                                classes.rsActiveIconWarBtn
                                              }
                                            ></Box>
                                          )}
                                        </Box>
                                        {/* </Box> */}
                                        <Box className="test">
                                          <Popper
                                            open={checkedAlert}
                                            placement={"bottom"}
                                            className={classes.rsWaringMenu}
                                            anchorEl={warningAnchorEl}
                                          >
                                            <ClickAwayListener
                                              onClickAway={handleClickAway}
                                            >
                                              <Collapse in={checkedAlert}>
                                                <ul
                                                  className={
                                                    classes.rsWaringFilterlistview
                                                  }
                                                >
                                                  <li
                                                    className={classes.rsCursor}
                                                    onClick={(e) => {
                                                      manageAlertFilter(
                                                        "2",
                                                        "alert",
                                                      );
                                                    }}
                                                  >
                                                    <Checkbox
                                                      value="2"
                                                      checked={warningTypeStatus.includes(
                                                        "2",
                                                      )}
                                                      onChange={() => {
                                                        navigate("/order");
                                                        manageAlertFilter(
                                                          "2",
                                                          "alert",
                                                        );
                                                      }}
                                                    />
                                                    <PrimaryIcon
                                                      width="20px"
                                                      height="20px"
                                                      icon={WarningIcon}
                                                    />
                                                    {"  "}
                                                    Warning
                                                  </li>
                                                  <li
                                                    className={classes.rsCursor}
                                                    onClick={(e) => {
                                                      manageAlertFilter(
                                                        "1",
                                                        "alert",
                                                      );
                                                    }}
                                                  >
                                                    <Checkbox
                                                      value="1"
                                                      checked={warningTypeStatus.includes(
                                                        "1",
                                                      )}
                                                      onChange={() => {
                                                        navigate("/order");
                                                        manageAlertFilter(
                                                          "1",
                                                          "alert",
                                                        );
                                                      }}
                                                    />
                                                    <PrimaryIcon
                                                      width="20px"
                                                      height="20px"
                                                      icon={ErrorIcon}
                                                    />
                                                    {"  "}
                                                    Error
                                                  </li>

                                                  <li
                                                    className={clsx(
                                                      classes.rsCursor,
                                                      classes.ordergapMain,
                                                    )}
                                                    onClick={(e) => {
                                                      manageAlertFilter(
                                                        "3",
                                                        "alert",
                                                      );
                                                    }}
                                                  >
                                                    <Checkbox
                                                      value="3"
                                                      checked={warningTypeStatus.includes(
                                                        "3",
                                                      )}
                                                      onChange={() => {
                                                        navigate("/order");
                                                        manageAlertFilter(
                                                          "3",
                                                          "alert",
                                                        );
                                                      }}
                                                    />
                                                    <PrimaryIcon
                                                      width="20px"
                                                      height="20px"
                                                      icon={Refresh}
                                                    />
                                                    {"  "}
                                                    Miss Match
                                                  </li>
                                                </ul>
                                              </Collapse>
                                            </ClickAwayListener>
                                          </Popper>
                                        </Box>
                                      </Box>
                                    ) : (
                                      <Box
                                        className={classes.rsIconFilterDispense}
                                      >
                                        <Box className={classes.rsiconBtn}>
                                          <FilterListIcon
                                            className={classes.rsCursor}
                                            onClick={(e) =>
                                              handleIconFilterChange(e)
                                            }
                                          />
                                          {(complianceStatus === true ||
                                            oosStatus === true ||
                                            patientTypeStatus?.length > 0 ||
                                            instalmentTypeStatus?.length > 0 ||
                                            patientFilterTypeStatus?.length >
                                            0) && (
                                              <Box
                                                className={
                                                  classes.rsActiveIconBtn
                                                }
                                              ></Box>
                                            )}
                                        </Box>
                                        <Box>
                                          <Popper
                                            open={checked}
                                            anchorEl={popperAnchorEl}
                                            placement={"bottom"}
                                            className={classes.rsPopperPage}
                                          >
                                            <ClickAwayListener
                                              onClickAway={handleClickAway}
                                            >
                                              <Collapse in={checked}>
                                                <ul
                                                  className={
                                                    classes.rsWaringFilterlistview
                                                  }
                                                >
                                                  <li
                                                    className={classes.rsCursor}
                                                    onClick={(e) => {
                                                      setOosStatus(!oosStatus);
                                                      if (oosStatus === true) {
                                                        navigate("/order");
                                                      }
                                                    }}
                                                  >
                                                    <Chips
                                                      label="Out of Sync"
                                                      color={
                                                        oosStatus
                                                          ? "rgba(123, 192, 68,0.6) "
                                                          : ""
                                                      }
                                                      variant={
                                                        oosStatus
                                                          ? "filled"
                                                          : "outlined"
                                                      }
                                                      borderColorChip={
                                                        oosStatus
                                                          ? ""
                                                          : "rgba(123, 192, 68,1)"
                                                      }
                                                      textColor={
                                                        oosStatus
                                                          ? "white"
                                                          : "rgba(123, 192, 68,1)"
                                                      }
                                                      border={
                                                        oosStatus ? "" : "3"
                                                      }
                                                      width="100px"
                                                    />
                                                  </li>
                                                  {/* <li
                                                    className={classes.rsCursor}
                                                    onClick={() =>
                                                      setComplianceStatus(
                                                        !complianceStatus
                                                      )
                                                    }
                                                  >
                                                    <Chips
                                                      label="Compliance"
                                                      color={
                                                        complianceStatus
                                                          ? "rgba(137, 156, 18, 0.6) "
                                                          : ""
                                                      }
                                                      variant={
                                                        complianceStatus
                                                          ? "filled"
                                                          : "outlined"
                                                      }
                                                      borderColorChip={
                                                        complianceStatus
                                                          ? ""
                                                          : "rgba(137, 156, 18, 1)"
                                                      }
                                                      textColor={
                                                        complianceStatus
                                                          ? "white"
                                                          : "rgba(137, 156, 18, 1)"
                                                      }
                                                      border={
                                                        complianceStatus
                                                          ? ""
                                                          : "3"
                                                      }
                                                      width="100px"
                                                    />
                                                  </li> */}
                                                  {/* <li
                                                    className={classes.rsCursor}
                                                    onClick={() =>
                                                      handleType("patient")
                                                    }
                                                  >
                                                    <Box
                                                      className={
                                                        classes.rsListAlignment
                                                      }
                                                    >
                                                      <Box>
                                                        Patient Type
                                                        {patientTypeStatus?.length >
                                                          0 && (
                                                          <Box
                                                            className={
                                                              classes.rsActiveBtn
                                                            }
                                                          ></Box>
                                                        )}
                                                      </Box>
                                                      <PrimaryIcon
                                                        width="20px"
                                                        height="20px"
                                                        icon={
                                                          patientTypeOpen
                                                            ? KeyboardArrowUpOutlinedIcon
                                                            : KeyboardArrowDownOutlinedIcon
                                                        }
                                                      />
                                                    </Box>
                                                  </li> */}
                                                  {/* <Collapse
                                                    in={patientTypeOpen}
                                                  >
                                                    <ul
                                                      className={
                                                        classes.rsWaringFilterlistview
                                                      }
                                                    >
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "collection",
                                                            "patient"
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Collection"
                                                          color={
                                                            patientTypeStatus.includes(
                                                              "collection"
                                                            )
                                                              ? "rgba(123, 192, 68,0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            patientTypeStatus.includes(
                                                              "collection"
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            patientTypeStatus.includes(
                                                              "collection"
                                                            )
                                                              ? ""
                                                              : "rgba(123, 192, 68,1)"
                                                          }
                                                          textColor={
                                                            patientTypeStatus.includes(
                                                              "collection"
                                                            )
                                                              ? "white"
                                                              : "rgba(123, 192, 68,1)"
                                                          }
                                                          border={
                                                            patientTypeStatus.includes(
                                                              "collection"
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>

                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "delivery",
                                                            "patient"
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Delivery"
                                                          color={
                                                            patientTypeStatus.includes(
                                                              "delivery"
                                                            )
                                                              ? "rgba(218, 120, 32, 0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            patientTypeStatus.includes(
                                                              "delivery"
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            patientTypeStatus.includes(
                                                              "delivery"
                                                            )
                                                              ? ""
                                                              : "rgba(218, 120, 32, 1)"
                                                          }
                                                          textColor={
                                                            patientTypeStatus.includes(
                                                              "delivery"
                                                            )
                                                              ? "white"
                                                              : "rgba(218, 120, 32, 1)"
                                                          }
                                                          border={
                                                            patientTypeStatus.includes(
                                                              "delivery"
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                    </ul>
                                                    <Divider
                                                      className={
                                                        classes.rsDivider
                                                      }
                                                    />
                                                  </Collapse> */}
                                                  {/* <li
                                                    className={classes.rsCursor}
                                                    onClick={() =>
                                                      handleType("dispense")
                                                    }
                                                  >
                                                    <Box
                                                      className={
                                                        classes.rsListAlignment
                                                      }
                                                    >
                                                      <Box>
                                                        Dispense
                                                        {instalmentTypeStatus?.length >
                                                          0 && (
                                                          <Box
                                                            className={
                                                              classes.rsActiveBtn
                                                            }
                                                          ></Box>
                                                        )}
                                                      </Box>
                                                      <PrimaryIcon
                                                        width="20px"
                                                        height="20px"
                                                        icon={
                                                          dispenseTypeOpen
                                                            ? KeyboardArrowUpOutlinedIcon
                                                            : KeyboardArrowDownOutlinedIcon
                                                        }
                                                      />
                                                    </Box>
                                                  </li> */}
                                                  {/* <Collapse
                                                    in={dispenseTypeOpen}
                                                  >
                                                    <ul
                                                      className={
                                                        classes.rsWaringFilterlistview
                                                      }
                                                    >
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "daily",
                                                            "dispense"
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Daily"
                                                          color={
                                                            instalmentTypeStatus.includes(
                                                              "daily"
                                                            ) == true
                                                              ? "rgba(56, 91, 177, 0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            instalmentTypeStatus.includes(
                                                              "daily"
                                                            ) == true
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            instalmentTypeStatus.includes(
                                                              "daily"
                                                            ) == true
                                                              ? ""
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          textColor={
                                                            instalmentTypeStatus.includes(
                                                              "daily"
                                                            ) == true
                                                              ? "white"
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          border={
                                                            instalmentTypeStatus.includes(
                                                              "daily"
                                                            ) == true
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "weekly",
                                                            "dispense"
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Weekly"
                                                          color={
                                                            instalmentTypeStatus.includes(
                                                              "weekly"
                                                            )
                                                              ? "rgba(56, 91, 177, 0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            instalmentTypeStatus.includes(
                                                              "weekly"
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            instalmentTypeStatus.includes(
                                                              "weekly"
                                                            )
                                                              ? ""
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          textColor={
                                                            instalmentTypeStatus.includes(
                                                              "weekly"
                                                            )
                                                              ? "white"
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          border={
                                                            instalmentTypeStatus.includes(
                                                              "weekly"
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "twice_weekly",
                                                            "dispense"
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Twice a Week"
                                                          color={
                                                            instalmentTypeStatus.includes(
                                                              "twice_weekly"
                                                            )
                                                              ? "rgba(56, 91, 177, 0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            instalmentTypeStatus.includes(
                                                              "twice_weekly"
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            instalmentTypeStatus.includes(
                                                              "twice_weekly"
                                                            )
                                                              ? ""
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          textColor={
                                                            instalmentTypeStatus.includes(
                                                              "twice_weekly"
                                                            )
                                                              ? "white"
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          border={
                                                            instalmentTypeStatus.includes(
                                                              "twice_weekly"
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "three_times_a_week",
                                                            "dispense"
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Thrice a Week"
                                                          color={
                                                            instalmentTypeStatus.includes(
                                                              "three_times_a_week"
                                                            )
                                                              ? "rgba(56, 91, 177, 0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            instalmentTypeStatus.includes(
                                                              "three_times_a_week"
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            instalmentTypeStatus.includes(
                                                              "three_times_a_week"
                                                            )
                                                              ? ""
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          textColor={
                                                            instalmentTypeStatus.includes(
                                                              "three_times_a_week"
                                                            )
                                                              ? "white"
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          border={
                                                            instalmentTypeStatus.includes(
                                                              "three_times_a_week"
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "fortnight",
                                                            "dispense"
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Fortnightly"
                                                          color={
                                                            instalmentTypeStatus.includes(
                                                              "fortnight"
                                                            )
                                                              ? "rgba(56, 91, 177, 0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            instalmentTypeStatus.includes(
                                                              "fortnight"
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            instalmentTypeStatus.includes(
                                                              "fortnight"
                                                            )
                                                              ? ""
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          textColor={
                                                            instalmentTypeStatus.includes(
                                                              "fortnight"
                                                            )
                                                              ? "white"
                                                              : "rgba(56, 91, 177, 1)"
                                                          }
                                                          border={
                                                            instalmentTypeStatus.includes(
                                                              "fortnight"
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                    </ul>
                                                    <Divider
                                                      className={
                                                        classes.rsDivider
                                                      }
                                                    />
                                                  </Collapse> */}
                                                  <li
                                                    className={classes.rsCursor}
                                                    onClick={() =>
                                                      handleType("status")
                                                    }
                                                  >
                                                    <Box
                                                      className={
                                                        classes.rsListAlignment
                                                      }
                                                    >
                                                      <Box>
                                                        Status
                                                        {patientFilterTypeStatus?.length >
                                                          0 && (
                                                            <Box
                                                              className={
                                                                classes.rsActiveBtn
                                                              }
                                                            ></Box>
                                                          )}
                                                      </Box>
                                                      <PrimaryIcon
                                                        width="20px"
                                                        height="20px"
                                                        icon={
                                                          statusTypeOpen
                                                            ? KeyboardArrowUpOutlinedIcon
                                                            : KeyboardArrowDownOutlinedIcon
                                                        }
                                                      />
                                                    </Box>
                                                  </li>
                                                  <Collapse in={statusTypeOpen}>
                                                    <ul
                                                      className={
                                                        classes.rsWaringFilterlistview
                                                      }
                                                    >
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "active",
                                                            "status",
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Active"
                                                          color={
                                                            patientFilterTypeStatus.includes(
                                                              "active",
                                                            )
                                                              ? "rgba(28, 176, 68,0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            patientFilterTypeStatus.includes(
                                                              "active",
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            patientFilterTypeStatus.includes(
                                                              "active",
                                                            )
                                                              ? ""
                                                              : "rgba(28, 176, 68,1)"
                                                          }
                                                          textColor={
                                                            patientFilterTypeStatus.includes(
                                                              "active",
                                                            )
                                                              ? "white"
                                                              : "rgba(28, 176, 68,1)"
                                                          }
                                                          border={
                                                            patientFilterTypeStatus.includes(
                                                              "active",
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "in_hospital",
                                                            "status",
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="In Hospital"
                                                          color={
                                                            patientFilterTypeStatus.includes(
                                                              "in_hospital",
                                                            )
                                                              ? "rgba(210, 162, 68,0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            patientFilterTypeStatus.includes(
                                                              "in_hospital",
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            patientFilterTypeStatus.includes(
                                                              "in_hospital",
                                                            )
                                                              ? ""
                                                              : "rgba(210, 162, 68,1)"
                                                          }
                                                          textColor={
                                                            patientFilterTypeStatus.includes(
                                                              "in_hospital",
                                                            )
                                                              ? "white"
                                                              : "rgba(210, 162, 68,1)"
                                                          }
                                                          border={
                                                            patientFilterTypeStatus.includes(
                                                              "in_hospital",
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "absent",
                                                            "status",
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Absent"
                                                          color={
                                                            patientFilterTypeStatus.includes(
                                                              "absent",
                                                            )
                                                              ? "rgba(107, 107, 107,0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            patientFilterTypeStatus.includes(
                                                              "absent",
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            patientFilterTypeStatus.includes(
                                                              "absent",
                                                            )
                                                              ? ""
                                                              : "rgba(107, 107, 107,1)"
                                                          }
                                                          textColor={
                                                            patientFilterTypeStatus.includes(
                                                              "absent",
                                                            )
                                                              ? "white"
                                                              : "rgba(107, 107, 107,1)"
                                                          }
                                                          border={
                                                            patientFilterTypeStatus.includes(
                                                              "absent",
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                      <li
                                                        className={
                                                          classes.rsCursor
                                                        }
                                                        onClick={(e) => {
                                                          manageDispenseFilter(
                                                            "deceased",
                                                            "status",
                                                          );
                                                        }}
                                                      >
                                                        <Chips
                                                          label="Deceased"
                                                          color={
                                                            patientFilterTypeStatus.includes(
                                                              "deceased",
                                                            )
                                                              ? "rgba(255, 0, 0,0.6) "
                                                              : ""
                                                          }
                                                          variant={
                                                            patientFilterTypeStatus.includes(
                                                              "deceased",
                                                            )
                                                              ? "filled"
                                                              : "outlined"
                                                          }
                                                          borderColorChip={
                                                            patientFilterTypeStatus.includes(
                                                              "deceased",
                                                            )
                                                              ? ""
                                                              : "rgba(255, 0, 0,1)"
                                                          }
                                                          textColor={
                                                            patientFilterTypeStatus.includes(
                                                              "deceased",
                                                            )
                                                              ? "white"
                                                              : "rgba(255, 0, 0,1)"
                                                          }
                                                          border={
                                                            patientFilterTypeStatus.includes(
                                                              "deceased",
                                                            )
                                                              ? ""
                                                              : "3"
                                                          }
                                                          width="100px"
                                                        />
                                                      </li>
                                                    </ul>
                                                  </Collapse>
                                                </ul>
                                              </Collapse>
                                            </ClickAwayListener>
                                          </Popper>
                                        </Box>
                                      </Box>
                                    ))}
                                </Box>
                              </TableCell>
                            ) : tableColumns[headCell].label === "ACTIONS" ||
                              tableColumns[headCell].label === "ORDER REVIEW" ||
                              tableColumns[headCell].label == "NURSING HOME" ||
                              tableColumns[headCell].label === "ADDRESS" ? (
                              <>
                                {tableColumns[headCell].label ===
                                  "ORDER REVIEW" && (
                                    <TableCell className={classes.luPrncell}>
                                      {tableColumns[headCell].label}
                                      <HtmlTooltip
                                        className="cursor-pointer"
                                        title="PRN review applies to patients whose medication requirements are variable month to month."
                                      >
                                        <HelpOutlineOutlinedIcon />
                                      </HtmlTooltip>
                                    </TableCell>
                                  )}
                                {(tableColumns[headCell].label === "ACTIONS" ||
                                  tableColumns[headCell].label === "ADDRESS" ||
                                  tableColumns[headCell].label ==
                                  "NURSING HOME") && (
                                    <TableCell>
                                      {tableColumns[headCell].label}
                                    </TableCell>
                                  )}
                              </>
                            ) : (
                              <TableCell>
                                {/* {tableColumns[headCell].icons === true && (
                                  <Box className={classes.rsWaringList}>
                                    {tableColumns[headCell].label}
                                    <Box className={classes.rsWaringList}>
                                      <Box className={classes.rsIconBtnWarning}>
                                        <FilterListIcon
                                          className={classes.rsWaringCursor}
                                          onClick={(e) =>
                                            handleWarningChange(e)
                                          }
                                        />
                                        {warningTypeStatus?.length > 0 && (
                                          <Box
                                            className={
                                              classes.rsActiveIconWarBtn
                                            }
                                          ></Box>
                                        )}
                                      </Box>
                                    </Box>
                                    <Box className="test">
                                      <Popper
                                        open={checkedAlert}
                                        placement={"bottom"}
                                        className={classes.rsWaringMenu}
                                        anchorEl={warningAnchorEl}
                                      >
                                        <ClickAwayListener
                                          onClickAway={handleClickAway}
                                        >
                                          <Collapse in={checkedAlert}>
                                            <ul
                                              className={
                                                classes.rsWaringFilterlistview
                                              }
                                            >
                                              <li
                                                className={classes.rsCursor}
                                                onClick={(e) => {
                                                  manageAlertFilter(
                                                    "2",
                                                    "alert"
                                                  );
                                                }}
                                              >
                                                <Checkbox
                                                  value="2"
                                                  checked={warningTypeStatus.includes(
                                                    "2"
                                                  )}
                                                  onChange={() =>
                                                    manageAlertFilter(
                                                      "2",
                                                      "alert"
                                                    )
                                                  }
                                                />
                                                <PrimaryIcon
                                                  width="20px"
                                                  height="20px"
                                                  icon={WarningIcon}
                                                />
                                                {"  "}
                                                Warning
                                              </li>
                                              <li
                                                className={classes.rsCursor}
                                                onClick={(e) => {
                                                  manageAlertFilter(
                                                    "1",
                                                    "alert"
                                                  );
                                                }}
                                              >
                                                <Checkbox
                                                  value="1"
                                                  checked={warningTypeStatus.includes(
                                                    "1"
                                                  )}
                                                  onChange={() =>
                                                    manageAlertFilter(
                                                      "1",
                                                      "alert"
                                                    )
                                                  }
                                                />
                                                <PrimaryIcon
                                                  width="20px"
                                                  height="20px"
                                                  icon={ErrorIcon}
                                                />
                                                {"  "}
                                                Error
                                              </li>
                                            </ul>
                                          </Collapse>
                                        </ClickAwayListener>
                                      </Popper>
                                    </Box>
                                  </Box>
                                )} */}
                              </TableCell>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody
                  className={clsx(classes.tableBodyLoading, classes.tableBody)}
                >
                  {repeatOrderList?.loading ? (
                    <TableCellLoader
                      cells={
                        showLoaderValue.filter(({ show }) => show === true)
                          .length
                      }
                    />
                  ) : repeatOrderList?.data?.list?.length > 0 ? (
                    repeatOrderList?.data?.list?.map((item, i) => {
                      const isSelected = (id) => selected?.indexOf(id) !== -1;
                      const isItemSelected = isSelected(item);
                      const labelId = `enhanced-table-checkbox-${i}`;
                      return (
                        <RepeatOrderTable
                          key={item?.id || item?.patient_id || i}
                          i={i}
                          item={item}
                          statusMenuItems={statusMenuItems}
                          setOpenEmailTemeplate={setOpenEmailTemeplate}
                          setOpenEmailTemplateId={setOpenEmailTemplateId}
                          setIsOrderRecordActionType={
                            setIsOrderRecordActionType
                          }
                          setIsOpenEditDateModel={setIsOpenEditDateModel}
                          setEditRepeatDate={setEditRepeatDate}
                          setShowOrderNoteList={setShowOrderNoteList}
                          setShowPatientNoteList={setShowPatientNoteList}
                          setDeletePatient={setDeletePatient}
                          setConfirmOpen={setConfirmOpen}
                          setOpenPatientNoteList={setOpenPatientNoteList}
                          setPatientDeleteId={setPatientDeleteId}
                          handleClickTickAction={handleClickTickAction}
                          isItemSelected={isItemSelected}
                          labelId={labelId}
                          setOpenOrderNoteList={setOpenOrderNoteList}
                          openCheckBoxColumn={openCheckBoxColumn}
                          setOpenOrderMedicationDate={
                            setOpenOrderMedicationDate
                          }
                          setShowOrderMedicationDateDetails={
                            setShowOrderMedicationDateDetails
                          }
                          showOrderMedicationDateDetails={
                            showOrderMedicationDateDetails
                          }
                          detailsDialog={detailsDialog}
                          setDetailsDialog={setDetailsDialog}
                          patientDetails={patientDetails}
                          setPatientDetails={setPatientDetails}
                          currentTableView={currentTableView}
                          setOpenConfirmEdit={setOpenConfirmEdit}
                          showOrderNoteList={showOrderNoteList}
                          tableCells={tableColumns}
                          prnReview={prnReview}
                          setPrnReview={setPrnReview}
                          cycleDialog={cycleDialog}
                          setCycleDialog={setCycleDialog}
                          setPRNitem={setPRNitem}
                          prnItem={prnItem}
                          setOrderPlace={setOrderPlace}
                          setOrderItemList={setOrderItemList}
                          orderPlace={orderPlace}
                          orderItemList={orderItemList}
                          orderId={orderId}
                          setOrderId={setOrderId}
                          isOrder={isOrder}
                          setisOrder={setisOrder}
                          prnWarning={prnWarning}
                          setPrnWarning={setPrnWarning}
                          patientDetailOpen={patientDetailOpen}
                          setPatientDetailOpen={setPatientDetailOpen}
                          patientId={patientId}
                          setPatientId={setPatientId}
                          warningOrderdate={warningOrderdate}
                          setWarningOrderdate={setWarningOrderdate}
                          getSingleRepeatOrderAction={
                            getSingleRepeatOrderAction
                          }
                          singleRepeatOrder={singleRepeatOrder}
                          clickOrderPlace={clickOrderPlace}
                          setClickOrderPlace={setClickOrderPlace}
                          openPatientStatus={openPatientStatus}
                          setOpenPatientStatus={setOpenPatientStatus}
                          setPatientStatus={setPatientStatus}
                        />
                      );
                    })
                  ) : (
                    <TableEmptyState />
                  )}
                  {repeatOrderList?.data?.list?.length !=
                    repeatOrderList?.data?.filterd_record && (
                      <TableLoadMore setRef={setTarget} />
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>

      {showPrientData == true && (
        <PrintRepeatOrderList
          repeatOrderList={printRepeatOrderList}
          globalSetting={globalSetting}
          showPrientData={showPrientData}
          tableColumns={tableColumns}
        />
      )}
      <React.Suspense fallback={null}>
        <EditDateDialog
          open={isOpenEditDateModel}
          setOpen={setIsOpenEditDateModel}
          editData={editRepeatDate}
          setEditData={setEditRepeatDate}
          orderRecordActionType={orderRecordActionType}
          getList={getList}
          loginUserDetail={loginUserDetail}
          subscriptionDialog={subscriptionDialog}
          setSubscritionDialog={setSubscritionDialog}
        />
        <PatientDetailDialog
          open={patientDetailOpen}
          setOpen={setPatientDetailOpen}
          patientId={patientId}
          setPatientId={setPatientId}
          getSinglePatientAction={getSinglePatientAction}
          data={singlePatientData}
          getPatientHistoryAction={getPatientHistoryAction}
          patientMedicationHistoryList={patientMedicationHistoryList}
          handleMediArchive={handleMediArchive}
          orderCountPayload={orderCountPayload}
          countUpdateFlag={true}
          getList={getList}
        />
        <PatientAndOrderNoteDialog
          open={openPatientNoteList}
          setOpen={setOpenPatientNoteList}
          showPatientNoteList={showPatientNoteList}
          actionBtnTitle="Ok"
          navigate={navigate}
          deleteRepeatOrderNoteAction={deleteRepeatOrderNoteAction}
          updateOrderNoteAction={updateOrderNoteAction}
          updateRepeatOrderNoteData={updateRepeatOrderNoteData}
          deleteRepeatOrderNote={deleteRepeatOrderNote}
          resetOrderState={resetOrderState}
          orderRecordActionType={orderRecordActionType}
          getPatientNoteListAction={getPatientNoteListAction}
          patientNoteList={patientNoteList}
          createPatientNoteAction={createPatientNoteAction}
          createPatientNoteData={createPatientNoteData}
          updatePatientNoteAction={updatePatientNoteAction}
          updatePatientNoteData={updatePatientNoteData}
          deletePatientNoteAction={deletePatientNoteAction}
          deletePatientNoteData={deletePatientNoteData}
          resetPatientState={resetPatientState}
          getSinglePatientNoteAction={getSinglePatientNoteAction}
          singlePatientNoteData={singlePatientNoteData}
          getListOrder={getList}
          setSubscritionDialog={setSubscritionDialog}
          loginUserDetail={loginUserDetail}
        />
        <OrderNoteDialog
          open={openOrderNoteList}
          setOpen={setOpenOrderNoteList}
          showOrderNoteList={showOrderNoteList}
          navigate={navigate}
          deleteRepeatOrderNoteAction={deleteRepeatOrderNoteAction}
          updateOrderNoteAction={updateOrderNoteAction}
          updateRepeatOrderNoteData={updateRepeatOrderNoteData}
          deleteRepeatOrderNote={deleteRepeatOrderNote}
          resetOrderState={resetOrderState}
          orderRecordActionType={orderRecordActionType}
          setIsOrderRecordActionType={setIsOrderRecordActionType}
        />
        <ConfirmationDialog
          open={deletePatient}
          setOpen={setDeletePatient}
          title="Are you sure?"
          body="You wan't be able to undo this order!"
          handleSubmit={handleDeleteRepeatOrder}
          actionBtnTitle="Yes Delete It!!"
          loading={deleteRepeatOrder?.loading}
        />
        <GlobalSettingDialog
          open={dlobalSettingDialogStatus}
          setOpen={setDlobalSettingDialogStatus}
          globalSetting={globalSetting}
          updateGlobalSettingAction={updateGlobalSettingAction}
          ordergapdays={ordergap}
          setOrdergapdays={setOrdergap}
          getList={getList}
        />
        {openEmailTemeplate && (
          <OutOfSyncTemplateDialog
            open={openEmailTemeplate}
            setOpen={setOpenEmailTemeplate}
            openEmailTemplateId={openEmailTemplateId}
            getOosOrderListAction={getOosOrderListAction}
            ossOrderList={ossOrderList}
          />
        )}
        <ConfirmDialog
          open={confirmOpen}
          setOpen={setConfirmOpen}
          title="Warning"
          subTitle={`You are ordering this prescription early.`}
          body="If you order a prescription too early your order request may be rejected by the surgery."
          actionBtnTitle="OK"
          handleSubmit={handleConfirmSubmit}
          showOrderNoteList={showOrderNoteList}
        />
        <MultiOrderDialog
          open={openMultiOrderPopup}
          setOpen={setOpenMultiOrderPopup}
          selected={(selected || []).filter(
            (item) =>
              (item?.id
                ? item
                : "" && ["Absent", "In-Hospital"].indexOf(item?.status) === -1) ||
              item?.order_type === "slow",
          )}
          resetOrderState={resetOrderState}
          setSelected={setSelected}
          getList={getList}
        />
        <SendEmailOrdersDialog
          open={openSendEmailOrdersPopup}
          setOpen={setOpenSendEmailOrdersPopup}
          selected={(selected || []).filter((item) => item?.id)}
          totalOrderCount={orderCountOfBulkOrder?.data?.today_order_count || 0}
          data={bulkOrderList?.data}
          loading={bulkOrderList?.loading}
        />
        <ReviewRequiredWaringDialog
          open={openReviewRequired}
          setOpen={setOpenReviewRequired}
          title="Warning"
          subTitle={`You cannot create multi-orders because your selected patient has medication review required.`}
          body={(selected || []).filter(
            (item) =>
              item?.order_type == "slow" &&
              ["Absent", "In-Hospital"].indexOf(item?.status) === -1,
          )}
          actionBtnTitle="OK"
        />
        <EarlyMultipleOrderDialog
          open={openEarlyMultiOrder}
          setOpen={setOpenEarlyMultiOrder}
          title="Warning"
          subTitle={`Early Order!`}
          body="Do you want to continue with the orders?"
          actionBtnTitle="OK"
          reviewRequiredPatient={(selected || []).filter(
            (item) =>
              (item?.is_early_order === true &&
                ["Absent", "In-Hospital"].indexOf(item?.status) === -1) ||
              item?.order_type === "slow",
          )}
          openMultiOrderPopup={openMultiOrderPopup}
          setOpenMultiOrderPopup={setOpenMultiOrderPopup}
        />
        <OrderMedicationDataDialog
          open={openOrderMedicationDate}
          setOpen={setOpenOrderMedicationDate}
          title="Order Date And Medication Date"
          showOrderMedicationDateDetails={showOrderMedicationDateDetails}
        />
        <InfomationDialog
          open={detailsDialog}
          setOpen={setDetailsDialog}
          patientDetails={patientDetails}
          setPatientDetails={setPatientDetails}
          type="repeatOrder"
        />
        <EditDateConfirmationDialog
          open={openConfirmEdit}
          setOpen={setOpenConfirmEdit}
          actionBtnTitle="Yes"
          setIsOpenEditDateModel={setIsOpenEditDateModel}
        />
        <TableColumnShowMenu
          open={openTableColumn}
          setOpen={setOpenTableColumn}
          anchorEl={columnsPopperAnchorEl}
          tableColumns={tableColumns}
          setTableColumns={setTableColumns}
          onOrderChange={(newOrder) => setTableColumns(newOrder)}
          tableCells={tableCells}
          orderRecordActionType={orderRecordActionType}
          moduleName={"repeatOrder"}
          tableViewType={currentTableView}
          handleOnChangeTableType={(tableType) => {
            setCurrentTableView(tableType);
          }}
        />
        <SearchAndFilterDialogMobileView
          open={openFilterPopup}
          setOpen={setOpenFilterPopup}
          maxValue={maxValue}
          surgeryListFlag={surgeryListFlag}
          changeSurgeryDropDownValue={changeSurgeryDropDownValue}
          handleSureryChange={handleSureryChange}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          handleSearch={handleSearch}
          groupListFlag={groupListFlag}
          changeGroupDropDownValue={changeGroupDropDownValue}
          handleGroupChange={handleGroupChange}
        />
        <PRNReviewDialog
          open={prnReview}
          setOpen={setPrnReview}
          setPRNitem={setPRNitem}
          prnItem={prnItem}
          getList={getList}
          setOrderPlace={setOrderPlace}
          isOrder={isOrder}
          setisOrder={setisOrder}
          orderId={orderId}
          setOrderId={setOrderId}
          prnWarning={prnWarning}
          setPrnWarning={setPrnWarning}
          setSubscritionDialog={setSubscritionDialog}
          loginUserDetail={loginUserDetail}
          clickOrder={clickOrder}
          setClickOrder={setClickOrder}
        />
        <OrderPlaceDialog
          open={orderPlace}
          setOpen={setOrderPlace}
          setOrderItemList={setOrderItemList}
          orderItemList={orderItemList}
          orderId={orderId}
          setOrderId={setOrderId}
          getList={getList}
          setSubscritionDialog={setSubscritionDialog}
          loginUserDetail={loginUserDetail}
        />
        <SubscriptionWaringDailog
          open={subscriptionDialog}
          setOpen={setSubscritionDialog}
        />
        <ConfirmDialog
          open={warningOrderdate}
          setOpen={setWarningOrderdate}
          title="Warning"
          body="Please add order date before placing order."
          orderdateWaring
        />
        <PatientActionColumn
          open={openPatientStatus}
          setOpen={setOpenPatientStatus}
          patientId={patientId}
          getList={getList}
          patientStatus={patientStatus}
          orderCountPayload={orderCountPayload}
          countUpdateFlag={true}
        />
      </React.Suspense>
    </>
  );
};

const mapStateToProps = (state) => ({
  repeatOrderList: state.order.repeatOrderList,
  deleteRepeatOrder: state.order.deleteRepeatOrder,
  globalSetting: state.order.globalSetting,
  printRepeatOrderList: state.order.printRepeatOrderList,
  updateRepeatOrderNoteData: state.order.updateRepeatOrderNoteData,
  deleteRepeatOrderNote: state.order.deleteRepeatOrderNote,
  patientNoteList: state.patient.patientNoteList,
  createPatientNoteData: state.patient.createPatientNoteData,
  updatePatientNoteData: state.patient.updatePatientNoteData,
  deletePatientNoteData: state.patient.deletePatientNoteData,
  singlePatientNoteData: state.patient.singlePatientNoteData,
  ossOrderList: state.order.ossOrderList,
  singlePatientData: state.patient.singlePatientData,
  patientMedicationHistoryList: state.patient.patientMedicationHistoryList,
  archiveMedi: state.patient.archiveMedi,
  orderCountTypeList: state.order.orderCountTypeList,
  singleRepeatOrder: state.order.singleRepeatOrder,
  orderCountOfBulkOrder: state.order.orderCountOfBulkOrder,
  bulkOrderList: state.order.bulkOrderList,
});
const mapDispatchToProps = (dispatch) => ({
  getPatientListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_LIST, payload }),
  getOrderListAction: (payload) =>
    dispatch({ type: START_GET_REPEAT_ORDER_LIST, payload }),
  resetOrderState: (key, payload) =>
    dispatch({ type: RESET_REPEAT_ORDER_STATE, key, payload }),
  deleteRepeatOrderAction: (id) =>
    dispatch({ type: START_DELETE_REPEAT_ORDER, id }),
  updateGlobalSettingAction: (payload, actionType) =>
    dispatch({ type: START_UPDATE_GLOBAL_SETTING, payload, actionType }),
  getPrintOrderListAction: (payload) =>
    dispatch({ type: START_GET_PRINT_REPEAT_ORDER_LIST, payload }),
  updateOrderNoteAction: (id, payload) =>
    dispatch({ type: START_UPDATE_REPEAT_ORDER_NOTE, id, payload }),
  deleteRepeatOrderNoteAction: (id) =>
    dispatch({ type: START_DELETE_REPEAT_ORDER_NOTE, id }),
  resetPatientState: (key, payload) =>
    dispatch({ type: RESET_PATIENT_STATE, key, payload }),
  getPatientNoteListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_NOTE_LIST, payload }),
  createPatientNoteAction: (payload) =>
    dispatch({ type: START_CREATE_PATIENT_NOTE, payload }),
  updatePatientNoteAction: (id, payload) =>
    dispatch({ type: START_UPDATE_PATIENT_NOTE, id, payload }),
  deletePatientNoteAction: (id, patient_id) =>
    dispatch({ type: START_DELETE_PATIENT_NOTE, id, patient_id }),
  getSinglePatientNoteAction: (id) =>
    dispatch({ type: START_GET_SINGLE_PATIENT_NOTE, id }),
  getOosOrderListAction: (payload) =>
    dispatch({ type: START_GET_OOS_ORDER, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getSinglePatientAction: (id) =>
    dispatch({ type: START_GET_SINGLE_PATIENT, id }),
  getPatientHistoryAction: (id, payload) =>
    dispatch({ type: START_GET_PATIENT_MEDICATION_HISTORY_LIST, id, payload }),
  getMedicationArchiveAction: (id, payload, historyPayload) =>
    dispatch({ type: START_ARCHIVE_MEDICATION, id, payload, historyPayload }),
  getOrderCountTypeAction: (payload) =>
    dispatch({ type: START_ORDER_COUNT_TYPE, payload }),
  getSingleRepeatOrderAction: (id) =>
    dispatch({ type: START_GET_SINGLE_REPEAT_ORDER, id }),
  getBulkOrderCountAction: (payload) =>
    dispatch({ type: START_BULK_ORDER_COUNT, payload }),
  getBulkOrderListAction: (payload) =>
    dispatch({ type: START_GET_BULK_ORDER_LIST, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(RepeatOrderMain);
